import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 143.81 89.57"
      {...props}
    >
      <defs>
        <style>
          {
            ".prefix__cls-1{fill:#fff}.prefix__cls-3{fill:#f2f2f2}.prefix__cls-4{fill:#fd8d8d}.prefix__cls-5{fill:#7c7c7c}.prefix__cls-7{fill:#a3a3a3}"
          }
        </style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <g id="prefix__Group_1053" data-name="Group 1053">
            <g id="prefix__Group_667" data-name="Group 667">
              <g id="prefix__Group_666" data-name="Group 666">
                <g id="prefix__Group_664" data-name="Group 664">
                  <path
                    id="prefix__Path_401"
                    data-name="Path 401"
                    className="prefix__cls-1"
                    d="M132.81 89l.05-1.09a1.61 1.61 0 10-3.21-.24V88.83l-2.86-.15.06-1.09a1.61 1.61 0 10-3.21-.24V88.51l-2.86-.14.06-1.09a1.61 1.61 0 10-3.21-.25.22.22 0 000 .08v1.09l-3.04-.2.06-1.09a1.61 1.61 0 10-3.21-.25.22.22 0 000 .08l-.06 1.09-2.85-.15.06-1.09a1.61 1.61 0 00-3.22-.17l-.06 1.09-2.85-.15.06-1.09a1.61 1.61 0 00-3.23-.27v.08l-.06 1.09-2.85-.15.06-1.02a1.61 1.61 0 00-3.22-.24v.08l-.06 1.08-2.85-.15.06-1.08a1.61 1.61 0 10-3.22-.25v.08l-.06 1.09-2.85-.15.06-1.09a1.61 1.61 0 00-3.22-.25v.08L81 86.26l-2.85-.15.08-1.11a1.61 1.61 0 00-3.23-.23V85.94l-1.9-.1.14-.51a1.61 1.61 0 00-1.11-2 2.25 2.25 0 00-.36-.06l-1.08-.06.15-2.85 1.08.06a1.61 1.61 0 10.08-3.2l-1-.06.15-2.85 1.09.06a1.61 1.61 0 10.17-3.22l-1.09-.06.15-2.85 1.09.06a1.61 1.61 0 00.25-3.22h-.08L71.59 65l.15-2.85 1.09.06a1.61 1.61 0 00.25-3.21H71.91l.15-2.85h1.09a1.61 1.61 0 00.17-3.21l-1.09-.06.15-2.88h1.08a1.6 1.6 0 001.66-1.56 1.62 1.62 0 00-1.49-1.66h-1.08l.14-2.78 1.09.06a1.61 1.61 0 10.22-3.27h-1.09l.09-2.91 1.09.06a1.61 1.61 0 00.17-3.22l-1.09-.06.15-2.85 1.09.06a1.61 1.61 0 00.17-3.22l-1.09-.06.15-2.85 1.09.06a1.61 1.61 0 00.17-3.22l-1.09-.06.19-2.85 1.09.06a1.61 1.61 0 10.24-3.22h-.08l-1.08-.06.15-2.85 1.08.06a1.61 1.61 0 00.17-3.22l-1.09-.06.15-2.85h1.09a1.61 1.61 0 00.17-3.21l-1.09-.06.09-1.76.6.32a1.48 1.48 0 00.68.19 1.6 1.6 0 001.69-1.52l.03-1.04 2.85.15-.06 1.09a1.61 1.61 0 003.22.17L84 .77l2.85.15-.1 1.08a1.61 1.61 0 003.25.18V1.09l2.85.15-.06 1.09a1.61 1.61 0 003.21.16l.06-1.08 2.94.14-.06 1.09a1.61 1.61 0 003.22.17l.06-1.09 2.85.15L105 3a1.61 1.61 0 003.22.17l.02-1.17 2.85.15-.09 1.13a1.61 1.61 0 003.22.17l.06-1.09 2.85.15-.03 1.09a1.61 1.61 0 003.22.17l.06-1.09 2.86.15-.06 1.09a1.6 1.6 0 001.52 1.69 1.62 1.62 0 001.7-1.53V3l2.86.15-.06 1.08a1.61 1.61 0 003.22.17l.06-1.09 2.85.15-.06 1.09a1.61 1.61 0 103.22.17l.06-1.09 2.55.14-.15.51a1.61 1.61 0 001.08 2 1.59 1.59 0 00.38.06 1.53 1.53 0 00.37 0l.53-.1-.18 3.43-1.09-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.15 2.85-1.09-.06a1.62 1.62 0 00-1.69 1.53 1.6 1.6 0 001.53 1.69l1.08.06-.15 2.85-1.08-.05a1.61 1.61 0 10-.17 3.21l1.09.06-.15 2.85-1.09-.05A1.61 1.61 0 00141 31h1.09l-.15 2.85h-1.09a1.61 1.61 0 00-.17 3.22h1.09l-.18 2.93h-1.09a1.61 1.61 0 00-.17 3.22h1.09l-.15 2.86-1.09-.08a1.61 1.61 0 00-.17 3.22l1.09.06-.1 2.87-1.08-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.15 2.85-1.09-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.15 2.85-1.09-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.2 2.85-1.09-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.15 2.85-1.09-.06a1.61 1.61 0 00-.17 3.22l1.09.06-.15 2.85-1.09-.06a1.62 1.62 0 00-.66 3.12h.08c.15.06.52.2.44.57s-.48.37-.72.35a1.62 1.62 0 00-1.69 1.52l-.06 1.09z"
                  />
                </g>
                <g id="prefix__Group_665" data-name="Group 665">
                  <path
                    id="prefix__Path_402"
                    data-name="Path 402"
                    d="M140.59 4.16a2 2 0 00.41 1.93 2 2 0 001.41.67 1.83 1.83 0 00.47 0l-.13 2.47h-.66a2 2 0 10-.21 4.06h.66l-.1 2h-.67a2 2 0 10-.21 4.06h.66l-.1 2h-.67a2 2 0 00-.21 4.06h.66l-.1 2h-.66a2 2 0 00-.22 4.07h.67l-.11 2h-.66a2 2 0 00-.22 4.07h.67l-.11 2h-.66a2 2 0 00-.21 4.07h.66l-.11 2h-.66a2 2 0 00-2.14 1.93 2 2 0 001.96 2.11h.66l-.1 2h-.67a2 2 0 00-.21 4.07h.66l-.1 2h-.67a2 2 0 00-2.14 1.92 2 2 0 001.93 2.14h.67l-.11 2h-.66a2 2 0 00-2.14 1.92 2 2 0 001.88 2.16h.67l-.11 2h-.66a2 2 0 00-2.14 1.92 2 2 0 001.92 2.14h.67l-.11 2h-.66a2 2 0 00-2.14 1.92A2 2 0 00138.4 80h.66l-.1 2h-.67a2 2 0 00-.84 3.93c.2.08.48.16 0 .13a2 2 0 00-2.16 1.94v.66l-2-.1v-.67a2 2 0 10-4.07-.21v.66l-2-.1v-.67a2 2 0 00-4.07-.21v.67l-2-.11v-.66a2 2 0 00-1.92-2.14 2 2 0 00-2.14 1.92v.67l-2-.11v-.66a2 2 0 00-1.92-2.14 2 2 0 00-2.17 1.93v.67l-2-.11v-.66a2 2 0 00-1.93-2.14 2 2 0 00-2.14 1.93v.66l-2-.1v-.67a2 2 0 10-4.06-.21v.66l-2-.1v-.67a2 2 0 00-1.92-2.14 2 2 0 00-2.14 1.93v.66l-2-.1v-.66a2 2 0 00-1.92-2.14 2 2 0 00-2.14 1.92v.67l-2-.11v-.66a2 2 0 00-4.06-.22v.67l-2-.11v-.66a2 2 0 00-4.07-.21v.66h-1a2 2 0 00-1.41-2.5 2.14 2.14 0 00-.44-.08h-.66l.1-2h.66a2 2 0 10.22-4.07h-.67l.11-2h.66a2 2 0 002.14-1.93 2 2 0 00-1.92-2.14h-.67l.11-2h.66a2 2 0 00.22-4.07h-.66l.1-2h.67a2 2 0 002.14-1.93A2 2 0 0073 58.58h-.66l.1-2h.67a2 2 0 002.14-1.93 2 2 0 00-1.93-2.14h-.66l.1-2h.67a2 2 0 002.13-1.93 2 2 0 00-1.92-2.14h-.67l.11-2h.66a2 2 0 00.26-4.07h-.67l.11-2h.66a2 2 0 00.22-4.06h-.66l.11-2h.66a2 2 0 10.22-4.06h-.66l.1-2h.67a2 2 0 10.21-4.07h-.66l.1-2h.67a2 2 0 10.21-4.07h-.66l.1-2h.66a2 2 0 10.17-4.11h-.67L75 8h.66a2 2 0 00.22-4.07h-.67v-.67A2 2 0 0078 2.42a2 2 0 00.25-.86V.89l2 .11v.66a2 2 0 004.07.22v-.67l2 .11v.66a2 2 0 004.07.21v-.66l2 .1v.67a2 2 0 104.06.21v-.66l2 .1v.67a2 2 0 104.06.21v-.66l2 .1v.67a2 2 0 104.06.21v-.67l2 .11v.66a2 2 0 001.92 2.14 2 2 0 002.14-1.92V2.8l2 .11v.66a2 2 0 001.93 2.14 2 2 0 002.14-1.93v-.66l2 .11v.66A2 2 0 00124.68 6a2 2 0 002.14-1.93v-.66l2 .1v.67a2 2 0 104.06.21v-.66l2 .1v.67a2 2 0 001.92 2.14 2 2 0 002.2-1.9v-.66l1.59.08m1.12-.79l-3.52-.19-.08 1.52a1.19 1.19 0 01-2.37-.13l.08-1.51-3.7-.2-.12 1.52a1.19 1.19 0 01-2.37-.13l.08-1.51-3.7-.19-.01 1.51a1.19 1.19 0 01-2.37-.13l.08-1.51-3.71-.19-.08 1.51a1.19 1.19 0 01-2.37-.12l.08-1.52-3.7-.19-.08 1.51a1.19 1.19 0 01-1.25 1.12 1.17 1.17 0 01-1.12-1.24l.08-1.52-3.71-.19-.07 1.51a1.19 1.19 0 01-2.4-.1l.08-1.51-3.7-.2-.08 1.51a1.19 1.19 0 11-2.37-.12l.08-1.51-3.7-.17-.08 1.52a1.19 1.19 0 11-2.37-.13l.08-1.56-3.7-.19-.08 1.51A1.19 1.19 0 1187.17 2l.08-1.49-3.7-.19-.08 1.51a1.19 1.19 0 01-2.37-.12l.08-1.52-3.7-.19-.08 1.51a1.2 1.2 0 01-1.25 1.13 1.08 1.08 0 01-.5-.15l-1.18-.64-.15 2.86 1.51.08a1.19 1.19 0 11-.13 2.37l-1.51-.08-.19 3.7 1.51.08a1.19 1.19 0 01-.12 2.37l-1.52-.08-.19 3.7 1.51.08a1.19 1.19 0 11-.12 2.37l-1.51-.08-.2 3.7 1.51.08A1.2 1.2 0 0176 24.25a1.19 1.19 0 01-1.25 1.12l-1.51-.08L73 29l1.52.07a1.19 1.19 0 01-.13 2.38l-1.51-.08-.19 3.7 1.51.08a1.19 1.19 0 01-.13 2.37l-1.51-.08-.19 3.7 1.51.08a1.19 1.19 0 11-.13 2.37l-1.51-.08-.19 3.7 1.51.08a1.19 1.19 0 01-.12 2.37L72 49.58l-.19 3.7 1.51.08a1.19 1.19 0 11-.12 2.37l-1.51-.08-.2 3.7 1.51.08a1.2 1.2 0 011.13 1.25 1.19 1.19 0 01-1.25 1.12l-1.51-.08-.2 3.71 1.52.08a1.19 1.19 0 01-.13 2.37L71 67.8l-.19 3.7 1.51.08A1.19 1.19 0 0172.2 74l-1.51-.08-.19 3.7 1.51.08a1.19 1.19 0 01-.12 2.3l-1.52-.08-.19 3.7 1.51.08a1.17 1.17 0 011.12 1.3.73.73 0 010 .25l-.28 1 2.86.15.07-1.51a1.19 1.19 0 012.34.11l-.08 1.52 3.7.19.08-1.51a1.19 1.19 0 011.24-1.13 1.2 1.2 0 011.13 1.25l-.08 1.51 3.7.2.08-1.51a1.19 1.19 0 112.37.12l-.08 1.51 3.7.2.08-1.52A1.19 1.19 0 1196 86l-.08 1.51 3.7.19.08-1.51a1.19 1.19 0 112.37.13l-.07 1.47 3.7.19.08-1.51a1.19 1.19 0 011.22-1.12 1.17 1.17 0 011.12 1.24l-.08 1.52 3.71.19.07-1.51a1.19 1.19 0 012.38.12l-.08 1.51 3.7.2.08-1.51a1.19 1.19 0 011.27-1.11 1.2 1.2 0 011.13 1.25l-.08 1.51 3.7.2.08-1.52a1.19 1.19 0 112.37.13l-.08 1.51 3.7.19.08-1.51a1.19 1.19 0 112.37.13l-.08 1.51 3.7.19.08-1.51a1.19 1.19 0 011.25-1.12h.31a.87.87 0 00.31-1.68l-.18-.07h-.07a1.2 1.2 0 01-.68-1.54 1.18 1.18 0 011.17-.75l1.51.08.2-3.71-1.51-.07a1.19 1.19 0 11.12-2.38l1.51.08.2-3.7-1.52-.08a1.19 1.19 0 01.13-2.37l1.51.08.19-3.7-1.51-.15a1.19 1.19 0 11.13-2.37l1.51.08.19-3.7-1.51-.01a1.19 1.19 0 01.12-2.37l1.52.08.19-3.71-1.51-.08a1.17 1.17 0 01-1.12-1.24 1.19 1.19 0 011.24-1.13l1.52.08.19-3.7-1.55-.12a1.19 1.19 0 01-1.13-1.24 1.2 1.2 0 011.25-1.13l1.51.08.2-3.7-1.51-.08a1.19 1.19 0 11.12-2.37l1.51.08.2-3.7-1.52-.08a1.19 1.19 0 11.13-2.37l1.51.08.19-3.7-1.46-.08a1.19 1.19 0 11.13-2.37l1.51.08.19-3.7-1.51-.08a1.19 1.19 0 01.12-2.37l1.52.08.19-3.7-1.51-.08a1.2 1.2 0 01-1.13-1.25 1.19 1.19 0 011.25-1.12l1.51.08.2-3.7-1.47-.08a1.2 1.2 0 01-1.13-1.25 1.19 1.19 0 011.2-1.14l1.51.07.23-4.39-1.05.19a.9.9 0 01-.28 0 1.17 1.17 0 01-1.12-1.24 1.26 1.26 0 010-.28l.31-1z"
                    fill="#e8e8e8"
                  />
                </g>
              </g>
            </g>
            <g id="prefix__Group_668" data-name="Group 668">
              <path
                id="prefix__Rectangle_291"
                data-name="Rectangle 291"
                className="prefix__cls-3"
                transform="rotate(-87 108.394 17.996)"
                d="M105.44-9.24h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_1054" data-name="Group 1054">
              <path
                id="prefix__Rectangle_291-2"
                data-name="Rectangle 291-2"
                className="prefix__cls-4"
                transform="rotate(-87 108.702 12.09)"
                d="M105.75-15.14h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_669" data-name="Group 669">
              <path
                id="prefix__Rectangle_292"
                data-name="Rectangle 292"
                className="prefix__cls-4"
                transform="rotate(-87 120.1 24.528)"
                d="M117.14 9.33h5.91v30.4h-5.91z"
              />
            </g>
            <g id="prefix__Group_670" data-name="Group 670">
              <path
                id="prefix__Rectangle_293"
                data-name="Rectangle 293"
                className="prefix__cls-3"
                transform="rotate(-87 107.774 29.804)"
                d="M104.82 2.57h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_671" data-name="Group 671">
              <path
                id="prefix__Rectangle_294"
                data-name="Rectangle 294"
                className="prefix__cls-4"
                transform="rotate(-87 107.46 35.705)"
                d="M104.51 8.47h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_672" data-name="Group 672">
              <path
                id="prefix__Rectangle_295"
                data-name="Rectangle 295"
                className="prefix__cls-3"
                transform="rotate(-87 107.153 41.612)"
                d="M104.2 14.38h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_673" data-name="Group 673">
              <path
                id="prefix__Rectangle_296"
                data-name="Rectangle 296"
                className="prefix__cls-4"
                transform="rotate(-87 106.85 47.513)"
                d="M103.89 20.28h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_674" data-name="Group 674">
              <path
                id="prefix__Rectangle_297"
                data-name="Rectangle 297"
                className="prefix__cls-3"
                transform="rotate(-87 106.537 53.414)"
                d="M103.58 26.19h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_675" data-name="Group 675">
              <path
                id="prefix__Rectangle_298"
                data-name="Rectangle 298"
                className="prefix__cls-4"
                transform="rotate(-87 106.23 59.32)"
                d="M103.27 32.09h5.91v54.46h-5.91z"
              />
            </g>
            <g id="prefix__Group_676" data-name="Group 676">
              <path
                id="prefix__Rectangle_299"
                data-name="Rectangle 299"
                className="prefix__cls-3"
                transform="rotate(-87 92.318 64.515)"
                d="M89.36 50.9h5.91v27.23h-5.91z"
              />
            </g>
            <g id="prefix__Group_677" data-name="Group 677">
              <path
                id="prefix__Rectangle_300"
                data-name="Rectangle 300"
                className="prefix__cls-4"
                transform="rotate(-87 92.015 70.416)"
                d="M89.06 56.8h5.91v27.23h-5.91z"
              />
            </g>
            <g id="prefix__Group_678" data-name="Group 678">
              <path
                id="prefix__Rectangle_301"
                data-name="Rectangle 301"
                className="prefix__cls-3"
                transform="rotate(-87 91.702 76.318)"
                d="M88.75 62.7h5.91v27.23h-5.91z"
              />
            </g>
            <g id="prefix__Group_679" data-name="Group 679">
              <path
                id="prefix__Path_403"
                data-name="Path 403"
                className="prefix__cls-5"
                d="M110.37 70.68l.18-3.53 1.62.08-.18 3.5a.89.89 0 101.78.17v-.08l.19-3.49 1.62.08-.19 3.53a2.52 2.52 0 01-5-.26z"
              />
              <path
                id="prefix__Path_404"
                data-name="Path 404"
                className="prefix__cls-5"
                d="M117.46 71.42l1.64.08a.61.61 0 00.57.65h.08c.33 0 .65-.14.67-.46s-.42-.49-1-.65c-.82-.25-1.87-.56-1.8-1.87.06-1.13.93-1.74 2.28-1.67s2.14.82 2.08 2l-1.59-.08a.54.54 0 00-.5-.57h-.08c-.28 0-.56.09-.57.36s.41.45 1 .62c.83.26 1.92.6 1.86 1.92s-1.07 1.86-2.41 1.79-2.29-.87-2.23-2.12z"
              />
              <path
                id="prefix__Path_405"
                data-name="Path 405"
                className="prefix__cls-5"
                d="M127.47 72.87l-2-.11-.37.92-1.7-.09 2.53-5.59 1.55.08 2 5.88-1.75-.09zm-.87-3.08l-.72 1.75 1.27.07z"
              />
            </g>
            <g id="prefix__Group_680" data-name="Group 680">
              <path
                id="prefix__Path_406"
                data-name="Path 406"
                className="prefix__cls-5"
                d="M110.65 75.16v.43h.87v.66h-.88v1h-.76l.14-2.74 1.74.1v.68z"
              />
              <path
                id="prefix__Path_407"
                data-name="Path 407"
                className="prefix__cls-5"
                d="M112.21 75.93a1.51 1.51 0 111.5 1.51h-.07a1.41 1.41 0 01-1.43-1.4zm2.22.11a.71.71 0 00-.69-.74.72.72 0 00-.06 1.44.7.7 0 00.76-.63V76z"
              />
              <path
                id="prefix__Path_408"
                data-name="Path 408"
                className="prefix__cls-5"
                d="M117 76.71h-.28v.84h-.75l.14-2.73 1.19.06a1 1 0 011 .94v.08a.88.88 0 01-.47.75l.49 1-.84-.05zm-.24-.65h.34a.3.3 0 10.11-.59h-.42z"
              />
              <path
                id="prefix__Path_409"
                data-name="Path 409"
                className="prefix__cls-5"
                d="M120.78 77.09v.66l-1.78-.1.14-2.73 1.75.09v.65l-1-.06v.4h.9v.62h-.9v.41z"
              />
              <path
                id="prefix__Path_410"
                data-name="Path 410"
                className="prefix__cls-5"
                d="M124.26 75.19l-1.19 2.68h-.7l-.92-2.87h.86l.47 1.73.63-1.67z"
              />
              <path
                id="prefix__Path_411"
                data-name="Path 411"
                className="prefix__cls-5"
                d="M126.6 77.4v.65l-1.81-.05.14-2.74 1.75.09V76h-1v.4h.89v.61h-.9v.41z"
              />
              <path
                id="prefix__Path_412"
                data-name="Path 412"
                className="prefix__cls-5"
                d="M128.46 77.31h-.27l-.05.83h-.75l.14-2.73 1.19.06a1 1 0 011 .94v.08a.86.86 0 01-.48.75l.49 1h-.84zm-.24-.65h.35a.3.3 0 00.35-.24.3.3 0 00-.25-.35h-.42z"
              />
            </g>
            <g id="prefix__Group_681" data-name="Group 681">
              <path
                id="prefix__Rectangle_302"
                data-name="Rectangle 302"
                transform="rotate(-87 93.062 20.15)"
                fill="#88baff"
                d="M81.24 8.12h23.65v24.06H81.24z"
              />
            </g>
            <g id="prefix__Group_682" data-name="Group 682">
              <path
                id="prefix__Path_413"
                data-name="Path 413"
                className="prefix__cls-1"
                d="M93.53 11.18l1.91 7.13 7.37.39-6.19 4 1.91 7.13-5.73-4.63-6.19 4 2.64-6.89-5.74-4.64 7.37.39z"
              />
            </g>
            <g id="prefix__Group_1052" data-name="Group 1052">
              <g id="prefix__Group_684" data-name="Group 684">
                <path
                  id="prefix__Path_415"
                  data-name="Path 415"
                  className="prefix__cls-7"
                  d="M77.08 20.73a.17.17 0 010 .07h.1l-.06-.08s-.02.02-.04.01z"
                />
              </g>
              <g id="prefix__Group_685" data-name="Group 685">
                <path
                  id="prefix__Path_416"
                  data-name="Path 416"
                  className="prefix__cls-7"
                  d="M80.86 25v.18l-.11.15a25.8 25.8 0 013.92 5.2l-.12-.36h.13a.52.52 0 01.14-.39l.18-.21.29.11a.82.82 0 01.2.12l.1-.2c-.34-.58-.7-1.15-1.08-1.69H84v-.34a.46.46 0 01.08-.34c-.22-.3-.46-.61-.7-.9h-.07l.29.42h-.53a.32.32 0 01-.1.1.48.48 0 01-.23.1.51.51 0 01-.24 0l-.21-.08-.06-.46.09-.12a.47.47 0 01.27-.18l.07-.2.34.09h.11c-.44-.53-.91-1-1.4-1.54h-.3v-.26a.17.17 0 000-.05l-.19-.18h-.1c-.42.17-.37.67-.26 1.03z"
                />
              </g>
              <g id="prefix__Group_687" data-name="Group 687">
                <path
                  id="prefix__Path_418"
                  data-name="Path 418"
                  className="prefix__cls-7"
                  d="M79.27 22.75l-.1.22h-.33a.17.17 0 000 .05L79 23l.11.34a.53.53 0 010 .44c.22.18.44.38.65.58 0-.07 0-.14.07-.22a3.29 3.29 0 01.21-.6.59.59 0 010-.59l-.21-.18-.23.29z"
                />
              </g>
              <g id="prefix__Group_688" data-name="Group 688">
                <path
                  id="prefix__Path_419"
                  data-name="Path 419"
                  className="prefix__cls-7"
                  d="M76.25 21.11l-.1-.11a.17.17 0 00.1.12z"
                />
              </g>
              <g id="prefix__Group_689" data-name="Group 689">
                <path
                  id="prefix__Path_420"
                  data-name="Path 420"
                  className="prefix__cls-7"
                  d="M88.16 39.16a.1.1 0 000-.06z"
                />
              </g>
              <g id="prefix__Group_690" data-name="Group 690">
                <path
                  id="prefix__Path_421"
                  data-name="Path 421"
                  className="prefix__cls-7"
                  d="M78 22.13h-.09-.07a.18.18 0 00-.08.11.19.19 0 01.13 0z"
                />
              </g>
              <g id="prefix__Group_691" data-name="Group 691">
                <path
                  id="prefix__Path_422"
                  data-name="Path 422"
                  className="prefix__cls-7"
                  d="M54.61 52.26h.07l.22-.1v-.1a.42.42 0 01-.29.2z"
                />
              </g>
              <g id="prefix__Group_692" data-name="Group 692">
                <path
                  id="prefix__Path_423"
                  data-name="Path 423"
                  className="prefix__cls-7"
                  d="M48.82 51.1a.4.4 0 01.21-.25v-.12l-.27.13-.35.13.42.24z"
                />
              </g>
              <g id="prefix__Group_693" data-name="Group 693">
                <path
                  id="prefix__Path_424"
                  data-name="Path 424"
                  className="prefix__cls-7"
                  d="M59.73 66.5l-.06.26a.36.36 0 01-.13.23 24 24 0 0011.76-1.6l-.46-.39a23.28 23.28 0 01-11.11 1.48z"
                />
              </g>
              <g id="prefix__Group_694" data-name="Group 694">
                <path
                  id="prefix__Path_425"
                  data-name="Path 425"
                  className="prefix__cls-7"
                  d="M38.62 44.73a.71.71 0 01.28-.06h.1v-1.53a.77.77 0 01-.27.08h-.28v1.58z"
                />
              </g>
              <g id="prefix__Group_695" data-name="Group 695">
                <path
                  id="prefix__Path_426"
                  data-name="Path 426"
                  className="prefix__cls-7"
                  d="M47.32 50.26h-.07l.11.08z"
                />
              </g>
              <g id="prefix__Group_696" data-name="Group 696">
                <path
                  id="prefix__Path_427"
                  data-name="Path 427"
                  className="prefix__cls-7"
                  d="M34.6 62.05a10.42 10.42 0 014.21-3.25.39.39 0 01-.15 0l-.68.35.27-.73a11.33 11.33 0 00-4.06 3.24A10.26 10.26 0 0129.86 65a.69.69 0 01-.05.13.3.3 0 01-.32.1.26.26 0 01-.16.07.32.32 0 01-.25-.07l-.52.11.05.26h-.35a.34.34 0 01-.32-.19h-.13a8.48 8.48 0 01-6.1-1.49.3.3 0 01-.16 0l.06.21h-.37a.36.36 0 01-.24-.07h-.05A9.29 9.29 0 0027.87 66c3.56-.45 5.13-2.23 6.73-3.95z"
                />
              </g>
              <g id="prefix__Group_697" data-name="Group 697">
                <path
                  id="prefix__Path_428"
                  data-name="Path 428"
                  className="prefix__cls-7"
                  d="M38.5 42.54a.62.62 0 01.63 0 8.61 8.61 0 013 .12h.29l-.06.06a11.89 11.89 0 013.84 2c.36.25.77.53 1.19.78h.09a11.54 11.54 0 001.29.7 13.53 13.53 0 002.23 5l.13.19-.22-.06a7 7 0 01-1.17-.4h-.16a.19.19 0 010 .07.43.43 0 010 .16l.15.12-.11.17a7.78 7.78 0 002 .57 13.71 13.71 0 001.24 1.29h.13a.85.85 0 01.23 0 1.85 1.85 0 01.46.08h.06a14.2 14.2 0 01-1.2-1.13l-.14-.15h.2a9.4 9.4 0 001.19 0h.07v.06a.57.57 0 00.12.18v-.14l.28-.07h.08l-.23-.06.08-.08a.45.45 0 010-.23v-.1a9.35 9.35 0 01-2.18 0 13 13 0 01-2.49-5v-.16l.15.05a6 6 0 00.64.2.69.69 0 010-.13v-.3h.09v-.07l-.27-.08a.54.54 0 01-.11.18l-.09.08h-.12a.45.45 0 01-.51-.32.55.55 0 01.11-.49v-.34l-.41-.2V45h-.07l-.15.07-.19.1v.35l-.15-.07a22.12 22.12 0 01-2-1.27 14.6 14.6 0 00-3.3-1.83H43v.1a.34.34 0 01-.25.18h-.35v-.26a.35.35 0 010-.17.38.38 0 01-.21 0h-.28v-.1a9 9 0 00-2.3-.1.55.55 0 01-.14.22.54.54 0 01-.52.06l-.22-.08-.11.1a.42.42 0 01-.17.1.45.45 0 01.05.14z"
                />
              </g>
              <g id="prefix__Group_698" data-name="Group 698">
                <path
                  id="prefix__Path_429"
                  data-name="Path 429"
                  className="prefix__cls-7"
                  d="M32.6 58.23l-.12-.47-.1-.07a9 9 0 01-1.25 1 .36.36 0 01.22.38.32.32 0 01-.28.27.36.36 0 01-.33-.34 8.51 8.51 0 01-3.53 1.16 8.15 8.15 0 01-5.29-1 .5.5 0 01-.41.08l-.17.22a8.85 8.85 0 005.94 1.25 8.68 8.68 0 005.32-2.48z"
                />
              </g>
              <g id="prefix__Group_699" data-name="Group 699">
                <path
                  id="prefix__Path_430"
                  data-name="Path 430"
                  className="prefix__cls-7"
                  d="M47.77 50.58h-.07z"
                />
              </g>
              <g id="prefix__Group_700" data-name="Group 700">
                <path
                  id="prefix__Path_431"
                  data-name="Path 431"
                  className="prefix__cls-7"
                  d="M50 58.75v.15h.2a1.07 1.07 0 01.47 0 1.51 1.51 0 01.09-.18z"
                />
              </g>
              <g id="prefix__Group_701" data-name="Group 701">
                <path
                  id="prefix__Path_432"
                  data-name="Path 432"
                  className="prefix__cls-7"
                  d="M27.1 54.92h.06-.11z"
                />
              </g>
              <g id="prefix__Group_702" data-name="Group 702">
                <path
                  id="prefix__Path_433"
                  data-name="Path 433"
                  className="prefix__cls-7"
                  d="M29 54.35v-.05a6.47 6.47 0 01-.84.3h.06l.15.16-.09.2a.32.32 0 01-.29.18 8.79 8.79 0 001.47-.5z"
                />
              </g>
              <g id="prefix__Group_703" data-name="Group 703">
                <path
                  id="prefix__Path_434"
                  data-name="Path 434"
                  className="prefix__cls-7"
                  d="M48.26 50.89v-.25h-.3z"
                />
              </g>
              <g id="prefix__Group_704" data-name="Group 704">
                <path
                  id="prefix__Path_435"
                  data-name="Path 435"
                  className="prefix__cls-7"
                  d="M50 56.07l.08.07h.1z"
                />
              </g>
              <g id="prefix__Group_706" data-name="Group 706">
                <path
                  id="prefix__Path_437"
                  data-name="Path 437"
                  className="prefix__cls-7"
                  d="M37.26 42.65l.09.26.3-.09v-.16a.44.44 0 01.15-.39l-.63.17a.72.72 0 01.09.21z"
                />
              </g>
              <g id="prefix__Group_707" data-name="Group 707">
                <path
                  id="prefix__Path_438"
                  data-name="Path 438"
                  className="prefix__cls-7"
                  d="M50.91 56.51z"
                />
              </g>
              <g id="prefix__Group_708" data-name="Group 708">
                <path
                  id="prefix__Path_439"
                  data-name="Path 439"
                  className="prefix__cls-7"
                  d="M27.37 54.79a.43.43 0 01.16 0h-.2z"
                />
              </g>
              <g id="prefix__Group_709" data-name="Group 709">
                <path
                  id="prefix__Path_440"
                  data-name="Path 440"
                  className="prefix__cls-7"
                  d="M26.33 55.33h.36a.33.33 0 01.06-.22h-.1.16l.07-.05.12-.12-.47.07a8.86 8.86 0 01-6.53-1.9h-.32v.14a2.74 2.74 0 01.09.39 9.27 9.27 0 006.84 1.82h.05z"
                />
              </g>
              <g id="prefix__Group_710" data-name="Group 710">
                <path
                  id="prefix__Path_441"
                  data-name="Path 441"
                  className="prefix__cls-7"
                  d="M38.71 41.8z"
                />
              </g>
              <g id="prefix__Group_711" data-name="Group 711">
                <path
                  id="prefix__Path_442"
                  data-name="Path 442"
                  className="prefix__cls-7"
                  d="M27.73 55.28z"
                />
              </g>
              <g id="prefix__Group_712" data-name="Group 712">
                <path
                  id="prefix__Path_443"
                  data-name="Path 443"
                  className="prefix__cls-7"
                  d="M42.3 60.67a1.39 1.39 0 01.65-.3 23.75 23.75 0 01-1.6-2l-.09-.12h.15a8.74 8.74 0 012.34.11l.41.49a.3.3 0 11.44.41 24 24 0 0014 7.55.49.49 0 010-.17l-.11-.31h.31a23.3 23.3 0 01-10.33-4.32.38.38 0 01-.28.17h-.5v-.31a.38.38 0 01.11-.3 22.53 22.53 0 01-2.89-2.72l-.23-.26.32.12a10.66 10.66 0 011.59.78l.32-.27.14-.1a9.61 9.61 0 00-3-1.25 23.67 23.67 0 01-2.94-4.75l-.03-.12h.13a8 8 0 014 .87v-.08l.45.09a.44.44 0 01.37.45c.46.28.92.59 1.35.89l.24.16L46 57.25l.46.41.83-.9.77.7a2 2 0 001.2.57 1.33 1.33 0 001-.46 1.49 1.49 0 00.31-.51v-.09h.08a5.39 5.39 0 00.68.22l.27.07-.27.09a2 2 0 00-.83.54l.12.06a.37.37 0 01.17.32v.23a1.58 1.58 0 012.68 1.68 1.52 1.52 0 01-2 .67l-.35.09.06-.25a1.56 1.56 0 01-.64-.94H49.95a2.19 2.19 0 001.14 1.59 3.16 3.16 0 00.5.22.37.37 0 01.2-.07l.54-.09v.26A2 2 0 0054 60.52a2.08 2.08 0 00-.76-2.85l-.24-.18h.32a10.39 10.39 0 001.58-.07.3.3 0 00.25-.31.28.28 0 00-.31-.24 9.48 9.48 0 01-2.13 0 .45.45 0 01-.25.18h-.2L52.1 57a.37.37 0 01-.12-.2 8.68 8.68 0 01-1-.27l-.17.07.33.06h-.47l-.13.05a.51.51 0 01-.32.08l-.25.32h-.07a.37.37 0 01-.15.13l-.31.17a1.09 1.09 0 01-1.06-.35h-.06l-.65-.59.62-.68h.07c.18.13.36.24.52.34l.09-.11.18.14.46.26.13-.06.15-.18.14.11.1-.09-.31-.2h-.07l-.28-.15c-.26-.15-.54-.32-.85-.52l-.09-.05.26-.28.78.71.3.29h.52a2.43 2.43 0 00-.5-.61l-.46-.42a.83.83 0 01-.34.1.57.57 0 01-.42-.09l-.23-.16.09-.26a.56.56 0 01.17-.26l-.66.71-.3-.2a16.64 16.64 0 00-2.66-1.58l-.08.09h-.2a.48.48 0 01-.35-.08.6.6 0 01-.22-.43 9 9 0 00-2.57-.4l-1.14.47a1.18 1.18 0 01-.4.1 1.47 1.47 0 01-1.1-.26l-.59.16h-.08v-.08A26.28 26.28 0 0137 48.59v-.07h.07A8.39 8.39 0 0138.8 48h.08v.08a24.06 24.06 0 001.23 4.17H40.69a22.94 22.94 0 01-1.27-4.21v-.09h.3c3.35-.4 5.17.84 7.08 2.15l.1.07a.74.74 0 01-.09-.33.71.71 0 01.07-.35l-.14-.1a9.56 9.56 0 00-5.83-2.06v.15l-.43-.08-.2.26-.09-.3h-.87v-.08c-.06-.38-.12-.76-.16-1.13s-.06-.53-.08-.8H39a.24.24 0 01-.12 0 .44.44 0 01-.36-.12l.09.9c0 .38.1.77.17 1.16v.08h-.08a8.26 8.26 0 00-1.69.52h-.1v-.18a.46.46 0 01-.28.17.38.38 0 01-.21 0 .41.41 0 01.22-.78H36.81v.05q-.07-.45-.12-.9a24.68 24.68 0 01-.18-3.1v-.05l.37-.14a.56.56 0 01-.47-.43l-.13-.37h.2v-.32.18l-.19.06a.4.4 0 01-.21.09h-.33v-.3a.48.48 0 01.07-.39l.14-.18.21.08a.5.5 0 01.2.15.86.86 0 010-.42.27.27 0 000-.12l-.06-.66a.27.27 0 01-.11-.18v-.05-.06l-.09-.36h.1a.44.44 0 010-.47l.14-.27v-.23l.42.36v-.2a.66.66 0 01-.49-.2.79.79 0 01-.23-.43l-.1.05-.13-.25a.2.2 0 010-.08l-.13.08v.11l-.06.29a.42.42 0 01.1.38.35.35 0 01-.1.2.83.83 0 010 .15v.28l-.24.05a25.49 25.49 0 00-.27 3.7v.05a8.9 8.9 0 00-1.15.87h.1v.16l.83-.28-.15.3.34-.26.13-.09v.16c0 .82.09 1.64.18 2.44s.19 1.34.32 2v.06a14.41 14.41 0 00-2.75 2.54 11.71 11.71 0 01-3.4 2.85l.25.2-.35.46a8 8 0 001.44-.84v-.05a.36.36 0 010-.32.42.42 0 01.28-.14l.6-.27c.54-.5 1-1 1.5-1.55a19.54 19.54 0 011.81-1.83.83.83 0 010-.15l.1-.3.25.1h.05l.15-.11.1-.08v.13a27.06 27.06 0 001.24 4v.07h-.07l-.15.08h.08l.16.13-.06.2a.4.4 0 01-.23.26h-.09a.5.5 0 01-.29-.07l.02.08v-.17c-.19.12-.37.25-.54.38v.14h-.22c-.22.18-.44.37-.66.58H35l.08.22a.35.35 0 01-.09.4.38.38 0 01-.23.11.34.34 0 01-.2 0 .39.39 0 01-.16-.15c-.3.31-.59.63-.85.91l-.72.8a.44.44 0 01.36.1l.12.12.08-.06v-.51l.4.15.21-.24c.45-.49.91-1 1.41-1.47h-.07v-.28a.34.34 0 01.1-.3.36.36 0 01.3-.08h.29v.12l.34-.26a.37.37 0 01.38-.35h.08c.16-.1.32-.18.48-.27h.08v.09A27 27 0 0039 57.06v-.32a.35.35 0 010-.17l-.05-.19H39.39l.08-.1.08.07.22-.09v.24l.2.16-.37.48-.11-.1h-.12l-.31.13c.14.25.3.5.45.74l.07.1h-.12l-.38.11a.21.21 0 01.1.06l.09.06h.23l-.15.13a.37.37 0 01-.12.2l.66-.19h.06v.05l.12.17a.58.58 0 01.19 0 .42.42 0 01.37.29.4.4 0 01-.1.39c.4.55.82 1.08 1.25 1.58h.05zm-6.73-20a.35.35 0 01-.13-.33v-.24l.61-.07.08.61-.23.08h-.1a.31.31 0 01-.21-.07zm.94 8.87h-.16a.43.43 0 01-.28-.38.41.41 0 01.2-.41h.07a.39.39 0 01.44.33.43.43 0 01-.32.49zm1.11 3.6l-.47-.38.37-.48.47.38zm3.28 4.66a25.84 25.84 0 01-2.28-4.2v-.09h.09a11 11 0 011.71-.35h.15v.05a24 24 0 002.65 4.5l.11.15h-.19a10.83 10.83 0 00-2.13 0z"
                />
              </g>
              <g id="prefix__Group_713" data-name="Group 713">
                <path
                  id="prefix__Path_444"
                  data-name="Path 444"
                  className="prefix__cls-7"
                  d="M45.6 64a.11.11 0 00.08 0 .13.13 0 000-.07.17.17 0 01-.1 0z"
                />
              </g>
              <g id="prefix__Group_714" data-name="Group 714">
                <path
                  id="prefix__Path_445"
                  data-name="Path 445"
                  className="prefix__cls-7"
                  d="M53.55 18.37h-.1a.19.19 0 00.16.11.16.16 0 00.1 0l-.08-.05a.12.12 0 01-.08-.06z"
                />
              </g>
              <g id="prefix__Group_715" data-name="Group 715">
                <path
                  id="prefix__Path_446"
                  data-name="Path 446"
                  className="prefix__cls-7"
                  d="M80.67 62.3z"
                />
              </g>
              <g id="prefix__Group_717" data-name="Group 717">
                <path
                  id="prefix__Path_448"
                  data-name="Path 448"
                  className="prefix__cls-7"
                  d="M80.77 62.6z"
                />
              </g>
              <g id="prefix__Group_718" data-name="Group 718">
                <path
                  id="prefix__Path_449"
                  data-name="Path 449"
                  className="prefix__cls-7"
                  d="M40.21 58.89h-.06z"
                />
              </g>
              <g id="prefix__Group_719" data-name="Group 719">
                <path
                  id="prefix__Path_450"
                  data-name="Path 450"
                  className="prefix__cls-7"
                  d="M72.86 19.75l.09.05a.22.22 0 000-.11h-.06z"
                />
              </g>
              <g id="prefix__Group_720" data-name="Group 720">
                <path
                  id="prefix__Path_451"
                  data-name="Path 451"
                  className="prefix__cls-7"
                  d="M72.74 19.75z"
                />
              </g>
              <g id="prefix__Group_721" data-name="Group 721">
                <path
                  id="prefix__Path_452"
                  data-name="Path 452"
                  className="prefix__cls-7"
                  d="M79.14 22.15z"
                />
              </g>
              <g id="prefix__Group_722" data-name="Group 722">
                <path
                  id="prefix__Path_453"
                  data-name="Path 453"
                  className="prefix__cls-7"
                  d="M78 22.64a.44.44 0 01-.37 0l.32.24a.46.46 0 01.05-.24z"
                />
              </g>
              <g id="prefix__Group_723" data-name="Group 723">
                <path
                  id="prefix__Path_454"
                  data-name="Path 454"
                  className="prefix__cls-7"
                  d="M73.39 19.3a.54.54 0 01-.25.35.41.41 0 010 .29c.42.19.84.4 1.26.62h.08a.24.24 0 01.08-.06l-.09-.34.42-.05a.41.41 0 01.38.13.38.38 0 01.09.3l.29.54h-.42l.1.06h.06l.48-.05-.2.22c.64.39 1.28.82 1.9 1.27a.39.39 0 01-.1-.47l.06-.15.16-.06a.49.49 0 01.24 0l.5.1a.61.61 0 00.27 0h.12c-.45-.35-.92-.69-1.4-1a.38.38 0 01-.35.14.2.2 0 010 .08.55.55 0 01-.37.22h-.11v.06h-.21a.41.41 0 01-.36-.39l-.08-.31.31-.11a.39.39 0 01.21 0 .48.48 0 01.35-.09c-.69-.44-1.41-.85-2.14-1.22h-.14a.42.42 0 01-.39-.26l-.38-.18a.58.58 0 010 .26.55.55 0 01-.37.1z"
                />
              </g>
              <g id="prefix__Group_724" data-name="Group 724">
                <path
                  id="prefix__Path_455"
                  data-name="Path 455"
                  className="prefix__cls-7"
                  d="M86.18 55.25a.47.47 0 01-.34-.19l-.34.08v-.54c-.21.43-.43.86-.67 1.28a.35.35 0 01.23.12l.17.18-.11.25a.37.37 0 01-.3.21h-.42A25.19 25.19 0 0181.11 61v.38a.42.42 0 010 .48l-.11.04H80.79a.46.46 0 01-.3-.08h-.33c-.21.21-.41.4-.61.58v.13h.22v.18l.13.05.1.24a.31.31 0 010 .08.41.41 0 01.06.32v.11a.46.46 0 01.3-.19l.58-.5v.1a27.28 27.28 0 005.54-7.51l-.14-.08a.48.48 0 01-.16-.08zm-5 7.2a.5.5 0 01-.28.39h-.13a.48.48 0 01-.28-.1l-.19-.15.06-.23a.48.48 0 01.31-.34.44.44 0 01.42.07l.16.13z"
                />
              </g>
              <g id="prefix__Group_725" data-name="Group 725">
                <path
                  id="prefix__Path_456"
                  data-name="Path 456"
                  className="prefix__cls-7"
                  d="M45.26 64.37v-.08z"
                />
              </g>
              <g id="prefix__Group_726" data-name="Group 726">
                <path
                  id="prefix__Path_457"
                  data-name="Path 457"
                  className="prefix__cls-7"
                  d="M80 63.71a.4.4 0 010-.15l-.08.16h-.23a.37.37 0 01-.25-.09l-.29.12v-.47A.4.4 0 0179 63c-.33.28-.68.56-1 .84l.06.3-.33.1h-.3l-.68.48h.08v.72h-.17l.07.16-.74-.2a.44.44 0 01-.19-.1 25.79 25.79 0 01-20.6 2.77h-.32V68l-.88-.22a.55.55 0 01-.2.39l-.14.09h-.17a.41.41 0 01-.28-.29.58.58 0 010-.43 26 26 0 01-9.33-6.06l-.63.4a.82.82 0 01-.65.12c.28.29.56.58.85.85H44.11l-.18.48.52.47h.14a.42.42 0 01.16-.09.48.48 0 01.42 0 .54.54 0 01.24-.21.45.45 0 01.56.15v.08a.4.4 0 01-.05.38.42.42 0 01-.36.17l-.35.16A27 27 0 0080 63.79z"
                />
              </g>
              <g id="prefix__Group_727" data-name="Group 727">
                <path
                  id="prefix__Path_458"
                  data-name="Path 458"
                  className="prefix__cls-7"
                  d="M88.29 49.71a3.63 3.63 0 01-.65-.09h-.31a25.09 25.09 0 01-1 3.15h.05a.43.43 0 01.42.22.48.48 0 010 .54l-.15.24-.27-.09a.43.43 0 01-.3-.3c-.12.3-.25.59-.39.88H86l.25.12.52-.08.08-.1.07.08.09.08c.17-.4.35-.81.51-1.23a.51.51 0 010-.49l.11-.15h.08c.14-.4.28-.82.4-1.23l-.14.08.35-.91a.37.37 0 01.07-.12c0-.17.08-.34.13-.51h-.12a.47.47 0 01-.11-.09z"
                />
              </g>
              <g id="prefix__Group_728" data-name="Group 728">
                <path
                  id="prefix__Path_459"
                  data-name="Path 459"
                  className="prefix__cls-7"
                  d="M36.44 35.3q-.27.86-.48 1.74l.4-.18v.49a.28.28 0 010 .09l.11.08h.32v.37a.17.17 0 010 .07 1.07 1.07 0 01.31.25c0-.2.08-.4.13-.6v-.05h.05c.42-.1.85-.17 1.27-.23a.43.43 0 01-.22-.18.41.41 0 010-.34c-.27 0-.54.08-.79.14h-.13v-.13a25.65 25.65 0 01.83-2.57.36.36 0 010-.27 6.5 6.5 0 01-1.07 1 .31.31 0 01-.06.13.36.36 0 01-.26.14.25.25 0 01-.12 0l-.17.09z"
                />
              </g>
              <g id="prefix__Group_729" data-name="Group 729">
                <path
                  id="prefix__Path_460"
                  data-name="Path 460"
                  className="prefix__cls-7"
                  d="M39.33 36.67h-.3a.69.69 0 010 .24v.3h.15a.46.46 0 01.37-.13.43.43 0 01.24.1h.07V37h-.34l.06-.29a.72.72 0 01-.24-.14v.06z"
                />
              </g>
              <g id="prefix__Group_730" data-name="Group 730">
                <path
                  id="prefix__Path_461"
                  data-name="Path 461"
                  className="prefix__cls-7"
                  d="M84.83 56.43a.14.14 0 00.09-.08h-.1l-.08.07a.14.14 0 00.09.01z"
                />
              </g>
              <g id="prefix__Group_732" data-name="Group 732">
                <path
                  id="prefix__Path_463"
                  data-name="Path 463"
                  className="prefix__cls-7"
                  d="M87.06 32.39l.07.09z"
                />
              </g>
              <g id="prefix__Group_733" data-name="Group 733">
                <path
                  id="prefix__Path_464"
                  data-name="Path 464"
                  className="prefix__cls-7"
                  d="M89.18 40.14a27.87 27.87 0 00-.5-2.9l-.05-.05-.3-.4.22-.09c-.1-.4-.21-.81-.33-1.21l-.17.2-.58-.46.16-.22-.4.06c-.29 0-.5-.12-.63-.47l-.12-.37a24.85 24.85 0 011 3.51V37.12l.5.21a.54.54 0 01.34.42l.26-.07-.07.46a.45.45 0 01.1.47l-.06.15v.25a.38.38 0 01-.21.32.37.37 0 01-.17.05l-.29.19.09.67a26.47 26.47 0 01.16 4.08l.23.18-.26.35c0 .73-.12 1.47-.23 2.22v.14a.59.59 0 000 .13v.26c0 .25-.09.5-.13.73l.57-.3-.18.29.51.4-.11.15a.55.55 0 01.25.07l.11.07a26.8 26.8 0 00.29-8.87z"
                />
              </g>
              <g id="prefix__Group_734" data-name="Group 734">
                <path
                  id="prefix__Path_465"
                  data-name="Path 465"
                  className="prefix__cls-7"
                  d="M87.41 33.36a.66.66 0 01-.36.45l-.26.11v.17l.47-.05.12.22a.93.93 0 01.15.26l.13.37.24-.3c-.16-.47-.33-.94-.52-1.4a.29.29 0 01.03.17z"
                />
              </g>
              <g id="prefix__Group_735" data-name="Group 735">
                <path
                  id="prefix__Path_466"
                  data-name="Path 466"
                  className="prefix__cls-7"
                  d="M55.66 18.21v.2a26 26 0 017.7-.86v-.08a.47.47 0 01-.33 0 .62.62 0 01-.27-.72l.1-.36.36.11a.58.58 0 01.41.35h.18a1.24 1.24 0 01.52.24.45.45 0 00.19.11l.25.05v.25a.76.76 0 010 .15A25.63 25.63 0 0170 18.72a.49.49 0 010-.2v-.24l.79-.09.07.61.2.29 1 .4-.1-.12-.14-.22.16-.2.07-.09a.41.41 0 01.09-.23l-.47.06-.09-.76a26.74 26.74 0 00-12.44-1.5h-.06a.58.58 0 01-.21.1h-.16l-.14-.08h-.37a.75.75 0 010 .16.78.78 0 01-.65.48h-.09l-.06.24-.44-.3a.81.81 0 01-.28-.3c-.76.16-1.51.35-2.23.57a.19.19 0 010 .08l.94.8zm9.54-1.78l.59.47-.46.59-.59-.49z"
                />
              </g>
              <g id="prefix__Group_736" data-name="Group 736">
                <path
                  id="prefix__Path_467"
                  data-name="Path 467"
                  className="prefix__cls-7"
                  d="M54 18.48z"
                />
              </g>
              <g id="prefix__Group_737" data-name="Group 737">
                <path
                  id="prefix__Path_468"
                  data-name="Path 468"
                  className="prefix__cls-7"
                  d="M72.55 18.28v.18h.24a.76.76 0 01.09-.09z"
                />
              </g>
              <g id="prefix__Group_738" data-name="Group 738">
                <path
                  id="prefix__Path_469"
                  data-name="Path 469"
                  className="prefix__cls-7"
                  d="M54.32 18.49l.44-.08.08.11a.69.69 0 01.19-.1l.23-.08-.76-.19v.08l.08.15h-.19a.34.34 0 01-.14.09z"
                />
              </g>
              <g id="prefix__Group_739" data-name="Group 739">
                <path
                  id="prefix__Path_470"
                  data-name="Path 470"
                  className="prefix__cls-7"
                  d="M39 31.62a1 1 0 010-.17v-.32h.35a.32.32 0 01.17 0 26.19 26.19 0 011.49-2.42h-.08c-.16-.06-.4-.25-.25-.71l.09-.3H41a.38.38 0 010-.21l-.05-.37h.42a.41.41 0 01.43.39.32.32 0 010 .17v.09l.11-.16.07-.08h.07a11.66 11.66 0 011.19.67v-.07a.49.49 0 010-.44v-.12l-.14-.08a.52.52 0 01-.36.19h-.08a.54.54 0 01-.44-.23l-.41-.69.66.1c.53-.63 1.1-1.25 1.69-1.84h-.08l-.13-.13a.72.72 0 01-.14-.62l.06-.25.49-.06.13.1a.64.64 0 01.2.43c.47-.44 1-.87 1.48-1.29a.31.31 0 010-.1v-.4h.38a.63.63 0 01.27.06 26.06 26.06 0 016.58-3.66.41.41 0 01.23-.36h.06-.06a.41.41 0 01-.36-.16l-.13-.15H52.73v-.22l-.12-.1-.77.3a.42.42 0 01-.27.16h-.13a27.24 27.24 0 00-10.24 7.8.88.88 0 01-.4.54l-.14.07-.08.1c-.36.49-.72 1-1 1.51A.63.63 0 0140 29a.55.55 0 010 .53l-.09.13h-.19a.53.53 0 01-.53-.27.36.36 0 010-.09c-.41.68-.8 1.39-1.16 2.12h-.18a9.28 9.28 0 00-3.36 1h.25v.37a1.29 1.29 0 010 .19 8.29 8.29 0 012.26-.82.31.31 0 01.08-.24.39.39 0 01.53-.12.45.45 0 01-.15.78c-.21.49-.41 1-.6 1.5l.19-.19a4.33 4.33 0 01.88-.72h.06v-.12a.61.61 0 01.07-.54.69.69 0 01.16-.18.53.53 0 01.23-.44v-.12l.16.06a.62.62 0 01.27 0l.12-.23z"
                />
              </g>
              <g id="prefix__Group_740" data-name="Group 740">
                <path
                  id="prefix__Path_471"
                  data-name="Path 471"
                  className="prefix__cls-7"
                  d="M43.32 61.16h.36L43.5 61a.69.69 0 01-.18.16z"
                />
              </g>
              <g id="prefix__Group_741" data-name="Group 741">
                <path
                  id="prefix__Path_472"
                  data-name="Path 472"
                  className="prefix__cls-7"
                  d="M86.07 32.18z"
                />
              </g>
              <g id="prefix__Group_742" data-name="Group 742">
                <path
                  id="prefix__Path_473"
                  data-name="Path 473"
                  className="prefix__cls-7"
                  d="M38.75 32.8l.07-.16a.64.64 0 01-.08.14z"
                />
              </g>
              <g id="prefix__Group_743" data-name="Group 743">
                <path
                  id="prefix__Path_474"
                  data-name="Path 474"
                  className="prefix__cls-7"
                  d="M86.61 33v-.62a.43.43 0 01-.13-.3l-.12-.44h.08a.51.51 0 010-.45v-.09c-.15-.3-.32-.62-.5-.94l-.15.09v.06a.43.43 0 01.1.09.52.52 0 01.14.46.44.44 0 01-.1.19.31.31 0 010 .13v.34l-.34.07h-.1a1.22 1.22 0 01-.33 0l.33.67v-.29l.74-.09.09.74-.28.1h-.12a.34.34 0 01-.26 0c.11.23.2.45.3.68l.09-.11.25.1h.1a.67.67 0 01.07-.31.3.3 0 00.14-.08z"
                />
              </g>
              <g id="prefix__Group_744" data-name="Group 744">
                <path
                  id="prefix__Path_475"
                  data-name="Path 475"
                  className="prefix__cls-7"
                  d="M70.6 21.56z"
                />
              </g>
              <g id="prefix__Group_745" data-name="Group 745">
                <path
                  id="prefix__Path_476"
                  data-name="Path 476"
                  className="prefix__cls-7"
                  d="M59.54 20.19h.17l-.44-.12a1.52 1.52 0 00-.42-.06.43.43 0 000 .05l-.07.26z"
                />
              </g>
              <g id="prefix__Group_746" data-name="Group 746">
                <path
                  id="prefix__Path_477"
                  data-name="Path 477"
                  className="prefix__cls-7"
                  d="M58.46 20.31h-.06v.05l.3-.05z"
                />
              </g>
              <g id="prefix__Group_747" data-name="Group 747">
                <path
                  id="prefix__Path_478"
                  data-name="Path 478"
                  className="prefix__cls-7"
                  d="M59.81 20.16a.48.48 0 01.13-.29l.1-.11h.15a.44.44 0 01.45.34h.32a.69.69 0 01.39-.19h.18l.13.13.07-.06a.61.61 0 01.41-.23h.18l.12.12a.41.41 0 01.13.23h.71a.14.14 0 010-.06l-.09-.3.29-.14h.06a24.1 24.1 0 00-3.8.11z"
                />
              </g>
              <g id="prefix__Group_748" data-name="Group 748">
                <path
                  id="prefix__Path_479"
                  data-name="Path 479"
                  className="prefix__cls-7"
                  d="M69 21l-.06-.14.36-.14a.31.31 0 01.13 0l-.06-.16a24.31 24.31 0 00-5.15-1v.15a.64.64 0 01-.05.41A23 23 0 0169 21z"
                />
              </g>
              <g id="prefix__Group_749" data-name="Group 749">
                <path
                  id="prefix__Path_480"
                  data-name="Path 480"
                  className="prefix__cls-7"
                  d="M49.45 23.82z"
                />
              </g>
              <g id="prefix__Group_750" data-name="Group 750">
                <path
                  id="prefix__Path_481"
                  data-name="Path 481"
                  className="prefix__cls-7"
                  d="M47.09 25.22h.15l-.15.42.4-.34.05-.15a.44.44 0 01.25-.27 1.89 1.89 0 01.16-.51 1.07 1.07 0 00.07-.19q-.54.4-1 .84h.13z"
                />
              </g>
              <g id="prefix__Group_751" data-name="Group 751">
                <path
                  id="prefix__Path_482"
                  data-name="Path 482"
                  className="prefix__cls-7"
                  d="M52.08 22.29a.41.41 0 010-.4v-.05l-.64.32a.64.64 0 01-.28.66v.09c.36-.2.71-.38 1.07-.56z"
                />
              </g>
              <g id="prefix__Group_752" data-name="Group 752">
                <path
                  id="prefix__Path_483"
                  data-name="Path 483"
                  className="prefix__cls-7"
                  d="M49 24.18a.34.34 0 010-.18.71.71 0 01-.13.26z"
                />
              </g>
              <g id="prefix__Group_753" data-name="Group 753">
                <path
                  id="prefix__Path_484"
                  data-name="Path 484"
                  className="prefix__cls-7"
                  d="M50.26 22.74c-.46.27-.91.55-1.35.85a.44.44 0 01.05.15v-.16l.74-.09v.21c.34-.22.69-.43 1-.63h-.13a.52.52 0 01-.31-.33z"
                />
              </g>
              <g id="prefix__Group_754" data-name="Group 754">
                <path
                  id="prefix__Path_485"
                  data-name="Path 485"
                  className="prefix__cls-7"
                  d="M55 21v.17l.68-.21v-.32a.39.39 0 01-.16.1.37.37 0 01-.3.28A.36.36 0 0155 21z"
                />
              </g>
              <g id="prefix__Group_755" data-name="Group 755">
                <path
                  id="prefix__Path_486"
                  data-name="Path 486"
                  className="prefix__cls-7"
                  d="M70.88 21.11z"
                />
              </g>
              <g id="prefix__Group_756" data-name="Group 756">
                <path
                  id="prefix__Path_487"
                  data-name="Path 487"
                  className="prefix__cls-7"
                  d="M82.2 30.58l-.08-.13a.31.31 0 01-.06.13.38.38 0 01-.18.13c.16.25.31.5.46.76l.32-.41.16.13c-.15-.25-.3-.5-.46-.75z"
                />
              </g>
              <g id="prefix__Group_757" data-name="Group 757">
                <path
                  id="prefix__Path_488"
                  data-name="Path 488"
                  className="prefix__cls-7"
                  d="M81.56 29.9a.4.4 0 01.32 0v-.16c-.27-.39-.55-.77-.85-1.15v.34a.44.44 0 01-.15.39l.48.67z"
                />
              </g>
              <g id="prefix__Group_758" data-name="Group 758">
                <path
                  id="prefix__Path_489"
                  data-name="Path 489"
                  className="prefix__cls-7"
                  d="M76.15 23.93a1.08 1.08 0 01-.55-.1.76.76 0 01-.4-.55 24.23 24.23 0 00-3.13-1.7l-.38.05.17.36h-.09a23.58 23.58 0 018.56 6.54h.16a.38.38 0 01.15 0l.36-.03a23.69 23.69 0 00-4.85-4.57z"
                />
              </g>
              <g id="prefix__Group_759" data-name="Group 759">
                <path
                  id="prefix__Path_490"
                  data-name="Path 490"
                  className="prefix__cls-7"
                  d="M39.29 38.52z"
                />
              </g>
              <g id="prefix__Group_760" data-name="Group 760">
                <path
                  id="prefix__Path_491"
                  data-name="Path 491"
                  className="prefix__cls-7"
                  d="M48.16 62l-.09.07a.17.17 0 00.12 0 .2.2 0 00.09-.09h-.1z"
                />
              </g>
              <g id="prefix__Group_762" data-name="Group 762">
                <path
                  id="prefix__Path_493"
                  data-name="Path 493"
                  className="prefix__cls-7"
                  d="M80.3 58.92a.49.49 0 01-.41-.22v-.06a23.07 23.07 0 01-2.19 2.16v.07a.44.44 0 010 .32v.3a24.08 24.08 0 002.58-2.57z"
                />
              </g>
              <g id="prefix__Group_763" data-name="Group 763">
                <path
                  id="prefix__Path_494"
                  data-name="Path 494"
                  className="prefix__cls-7"
                  d="M77.75 61.5h-.41a.41.41 0 01-.29-.13c-.25.21-.51.42-.78.61a.5.5 0 010 .27.53.53 0 01-.33.34l-.24.2-.22-.24c-.28.2-.57.38-.86.57a.53.53 0 01-.22.12l-.34.2h.28l.05.4h.07v-.38l.32-.06a.42.42 0 01.27 0l.15-.23.1.13a23.7 23.7 0 002.45-1.8z"
                />
              </g>
              <g id="prefix__Group_764" data-name="Group 764">
                <path
                  id="prefix__Path_495"
                  data-name="Path 495"
                  className="prefix__cls-7"
                  d="M73.48 64.16a.41.41 0 01-.18 0l.07.23-.48-.13-.06.08h-.22l-.17.51-.22-.33a3.39 3.39 0 01-.39.18.19.19 0 000 .08.92.92 0 000 .16l.09.32c.6-.26 1.2-.56 1.77-.87h-.06z"
                />
              </g>
              <g id="prefix__Group_765" data-name="Group 765">
                <path
                  id="prefix__Path_496"
                  data-name="Path 496"
                  className="prefix__cls-7"
                  d="M77.47 61a.12.12 0 010 .1v.1l.07-.05a.14.14 0 000-.14z"
                />
              </g>
              <g id="prefix__Group_766" data-name="Group 766">
                <path
                  id="prefix__Path_497"
                  data-name="Path 497"
                  className="prefix__cls-7"
                  d="M44.36 59.05z"
                />
              </g>
              <g id="prefix__Group_768" data-name="Group 768">
                <path
                  id="prefix__Path_499"
                  data-name="Path 499"
                  className="prefix__cls-7"
                  d="M80.33 58.07a.85.85 0 01.23 0l.36.08a23.57 23.57 0 004.4-8.72h-.07a2.05 2.05 0 01-.55.16 23.64 23.64 0 01-4.37 8.48z"
                />
              </g>
              <g id="prefix__Group_770" data-name="Group 770">
                <path
                  id="prefix__Path_501"
                  data-name="Path 501"
                  className="prefix__cls-7"
                  d="M40.42 33.9a.34.34 0 010 .1h.07a.38.38 0 01.25.09.54.54 0 01.07-.39.5.5 0 01.54-.52v-.08h-.21a.45.45 0 01-.36 0c-.12.25-.24.5-.35.77z"
                />
              </g>
              <g id="prefix__Group_771" data-name="Group 771">
                <path
                  id="prefix__Path_502"
                  data-name="Path 502"
                  className="prefix__cls-7"
                  d="M41.6 32.63h-.05v.1z"
                />
              </g>
              <g id="prefix__Group_772" data-name="Group 772">
                <path
                  id="prefix__Path_503"
                  data-name="Path 503"
                  className="prefix__cls-7"
                  d="M81.58 30.27v-.05a.08.08 0 010 .05z"
                />
              </g>
              <g id="prefix__Group_773" data-name="Group 773">
                <path
                  id="prefix__Path_504"
                  data-name="Path 504"
                  className="prefix__cls-7"
                  d="M84.37 35.35l-.16.06c.09.24.17.49.25.74l.5-.23c-.08-.26-.17-.52-.27-.79a.87.87 0 01-.32.22z"
                />
              </g>
              <g id="prefix__Group_774" data-name="Group 774">
                <path
                  id="prefix__Path_505"
                  data-name="Path 505"
                  className="prefix__cls-7"
                  d="M38.79 39.81a.24.24 0 01-.08.06c0 .18 0 .35-.07.52h.3l-.09.34H39l.11-.08c0-.33.08-.67.13-1h-.16a.42.42 0 01-.29.16z"
                />
              </g>
              <g id="prefix__Group_775" data-name="Group 775">
                <path
                  id="prefix__Path_506"
                  data-name="Path 506"
                  className="prefix__cls-7"
                  d="M40.06 35a.25.25 0 010-.19l-.06.05a.17.17 0 00.06.14z"
                />
              </g>
              <g id="prefix__Group_776" data-name="Group 776">
                <path
                  id="prefix__Path_507"
                  data-name="Path 507"
                  className="prefix__cls-7"
                  d="M40.13 36.13c0-.15.1-.3.16-.45l-.1-.06-.14-.1v-.18h-.16v-.09c-.07.19-.14.38-.2.57a.62.62 0 01.45.29.05.05 0 01-.01.02z"
                />
              </g>
              <g id="prefix__Group_778" data-name="Group 778">
                <path
                  id="prefix__Path_509"
                  data-name="Path 509"
                  className="prefix__cls-7"
                  d="M39.35 38.19a.38.38 0 01-.13.06h.15a.53.53 0 01.17 0c0-.11.05-.22.07-.34h-.11a.41.41 0 01-.15.28z"
                />
              </g>
              <g id="prefix__Group_779" data-name="Group 779">
                <path
                  id="prefix__Path_510"
                  data-name="Path 510"
                  className="prefix__cls-7"
                  d="M39 38.52a.41.41 0 01.05-.09H39z"
                />
              </g>
              <g id="prefix__Group_780" data-name="Group 780">
                <path
                  id="prefix__Path_511"
                  data-name="Path 511"
                  className="prefix__cls-7"
                  d="M39 38.79a.34.34 0 01-.14.19v.16L39 39z"
                />
              </g>
              <g id="prefix__Group_781" data-name="Group 781">
                <path
                  id="prefix__Path_512"
                  data-name="Path 512"
                  className="prefix__cls-7"
                  d="M57.05 20.54h-.08.08v.07l.88-.19h-.23a1 1 0 01-.76-.3h-.16a.47.47 0 01.27.42z"
                />
              </g>
              <g id="prefix__Group_782" data-name="Group 782">
                <path
                  id="prefix__Path_513"
                  data-name="Path 513"
                  className="prefix__cls-7"
                  d="M82.66 32z"
                />
              </g>
              <g id="prefix__Group_783" data-name="Group 783">
                <path
                  id="prefix__Path_514"
                  data-name="Path 514"
                  className="prefix__cls-7"
                  d="M56.79 20.47z"
                />
              </g>
              <g id="prefix__Group_784" data-name="Group 784">
                <path
                  id="prefix__Path_515"
                  data-name="Path 515"
                  className="prefix__cls-7"
                  d="M84.94 36.44l.18.18-.07.17.07.26H85v.27a.42.42 0 01.19.53.34.34 0 01-.1.16 23.78 23.78 0 01.44 2.5c0 .17 0 .35.06.55l.28.1h.28c0-.26 0-.52-.07-.77a24.15 24.15 0 00-.93-4.31z"
                />
              </g>
              <g id="prefix__Group_785" data-name="Group 785">
                <path
                  id="prefix__Path_516"
                  data-name="Path 516"
                  className="prefix__cls-7"
                  d="M86 45.62a23.52 23.52 0 00.08-3.46h-.24a.57.57 0 01-.18 0h-.1a23.23 23.23 0 01-.09 3.54l.53-.1z"
                />
              </g>
              <g id="prefix__Group_786" data-name="Group 786">
                <path
                  id="prefix__Path_517"
                  data-name="Path 517"
                  className="prefix__cls-7"
                  d="M85.32 47l.06.15a.45.45 0 01-.11.49h-.07c0 .22-.09.46-.15.71l.15-.05a.64.64 0 01.43 0q.11-.48.18-1h-.35v-.34a.43.43 0 01.13-.37.42.42 0 01.36-.1v-.09l-.56.07c-.02.16-.05.32-.07.53z"
                />
              </g>
              <g id="prefix__Group_787" data-name="Group 787">
                <path
                  id="prefix__Path_518"
                  data-name="Path 518"
                  className="prefix__cls-7"
                  d="M40.33 34.49h.08a.13.13 0 010-.12h-.06a.12.12 0 00-.02.12z"
                />
              </g>
              <g id="prefix__Group_788" data-name="Group 788">
                <path
                  id="prefix__Path_519"
                  data-name="Path 519"
                  className="prefix__cls-7"
                  d="M40.45 34.26z"
                />
              </g>
              <g id="prefix__Group_789" data-name="Group 789">
                <path
                  id="prefix__Path_520"
                  data-name="Path 520"
                  className="prefix__cls-7"
                  d="M83.86 34.49h.1l.14-.08-.47-.41c.08.15.16.32.23.49z"
                />
              </g>
              <g id="prefix__Group_790" data-name="Group 790">
                <path
                  id="prefix__Path_521"
                  data-name="Path 521"
                  className="prefix__cls-7"
                  d="M83.8 33c-.07-.16-.15-.31-.23-.46v.1l-.39-.13-.18-.06h-.07c.15.28.29.58.43.87z"
                />
              </g>
              <g id="prefix__Group_791" data-name="Group 791">
                <path
                  id="prefix__Path_522"
                  data-name="Path 522"
                  className="prefix__cls-7"
                  d="M83.47 33.61v.1h.59c-.08-.18-.16-.37-.25-.56z"
                />
              </g>
              <g id="prefix__Group_792" data-name="Group 792">
                <path
                  id="prefix__Path_523"
                  data-name="Path 523"
                  className="prefix__cls-7"
                  d="M65.38 56.25h-.12a.23.23 0 00.06.16.16.16 0 00.17 0l-.06-.07a.09.09 0 010-.06z"
                />
              </g>
              <g id="prefix__Group_793" data-name="Group 793">
                <path
                  id="prefix__Path_524"
                  data-name="Path 524"
                  className="prefix__cls-7"
                  d="M65.54 56.21h.08a.21.21 0 00-.05-.12h-.08z"
                />
              </g>
              <g id="prefix__Group_794" data-name="Group 794">
                <path
                  id="prefix__Path_525"
                  data-name="Path 525"
                  className="prefix__cls-7"
                  d="M57.35 30.5v-.07l-.53.22a.45.45 0 01.15.21.62.62 0 010 .3l.18-.07a.29.29 0 01.12-.1l.06-.06.09-.08-.19-.1z"
                />
              </g>
              <g id="prefix__Group_795" data-name="Group 795">
                <path
                  id="prefix__Path_526"
                  data-name="Path 526"
                  className="prefix__cls-7"
                  d="M52.34 36.54a.36.36 0 00.12.18v-.16a.3.3 0 01-.12-.02z"
                />
              </g>
              <g id="prefix__Group_796" data-name="Group 796">
                <path
                  id="prefix__Path_527"
                  data-name="Path 527"
                  className="prefix__cls-7"
                  d="M52.48 34.14a.56.56 0 01-.33.08h-.28a13.6 13.6 0 00-1.25 1.66H50v.06h.63v.38a.56.56 0 01-.23.43.81.81 0 01-.29.12L50 37a.42.42 0 01-.14.27l.13.09a.45.45 0 01.3-.07h.17c.13-.27.28-.54.43-.79H51a11.66 11.66 0 001.18-.06A.44.44 0 0152 36v-.13h-.77l.1-.14A13.9 13.9 0 0152.86 34v-.14a.67.67 0 01-.38.28z"
                />
              </g>
              <g id="prefix__Group_797" data-name="Group 797">
                <path
                  id="prefix__Path_528"
                  data-name="Path 528"
                  className="prefix__cls-7"
                  d="M46.72 35.32a9.19 9.19 0 001.46.68.47.47 0 01-.18-.29.44.44 0 01.06-.35c-.3-.12-.59-.26-.88-.41h-.07l-.25.1a2.86 2.86 0 01-.41.15l-.25.06.13.26-.32-.1-.06.13.16.07.26.08.23-.46z"
                />
              </g>
              <g id="prefix__Group_798" data-name="Group 798">
                <path
                  id="prefix__Path_529"
                  data-name="Path 529"
                  className="prefix__cls-7"
                  d="M49.53 36.23a.31.31 0 01-.13 0 .42.42 0 01-.27-.32l-.05-.18-.24-.06a.57.57 0 010 .18l-.06.22-.25.05h-.07a7.8 7.8 0 001.06.26.56.56 0 01.01-.15z"
                />
              </g>
              <g id="prefix__Group_799" data-name="Group 799">
                <path
                  id="prefix__Path_530"
                  data-name="Path 530"
                  className="prefix__cls-7"
                  d="M63.36 29.88z"
                />
              </g>
              <g id="prefix__Group_801" data-name="Group 801">
                <path
                  id="prefix__Path_532"
                  data-name="Path 532"
                  className="prefix__cls-7"
                  d="M63.5 29.91a.12.12 0 010 .1h-.09a.14.14 0 00.16-.11.13.13 0 000-.06z"
                />
              </g>
              <g id="prefix__Group_803" data-name="Group 803">
                <path
                  id="prefix__Path_534"
                  data-name="Path 534"
                  className="prefix__cls-7"
                  d="M59 56.18v.53a11.16 11.16 0 001.4.27H60.85a12.75 12.75 0 002.62 0 .25.25 0 010-.07l.07-.2h.21a.43.43 0 01.16 0h.15v-.24l.78-.1.06.48 1-.23.06-.35.12.1v-.09l.26-.12a.61.61 0 01.33 0l.27.08a.31.31 0 01.13.06 13.44 13.44 0 001.69-.76l-.2-.14-.09-.09h-.08l-.09-.05v-.06a13.73 13.73 0 01-2.47 1 .38.38 0 01-.06.41.4.4 0 01-.27.16.36.36 0 01-.25-.06.39.39 0 01-.17-.33 10.17 10.17 0 01-1.21.2 13.21 13.21 0 01-4.87-.4z"
                />
              </g>
              <g id="prefix__Group_804" data-name="Group 804">
                <path
                  id="prefix__Path_535"
                  data-name="Path 535"
                  className="prefix__cls-7"
                  d="M73.44 51.48a.46.46 0 01-.07-.16l-.12-.44h.62a13.8 13.8 0 002.23-6.93.88.88 0 01-.36.1h-.2a13.23 13.23 0 01-6.33 10.61.51.51 0 01.14.26V55a.43.43 0 01-.1.24 13.77 13.77 0 004.19-3.76z"
                />
              </g>
              <g id="prefix__Group_805" data-name="Group 805">
                <path
                  id="prefix__Path_536"
                  data-name="Path 536"
                  className="prefix__cls-7"
                  d="M69 55.43l-.09.06z"
                />
              </g>
              <g id="prefix__Group_806" data-name="Group 806">
                <path
                  id="prefix__Path_537"
                  data-name="Path 537"
                  className="prefix__cls-7"
                  d="M49.07 42.21z"
                />
              </g>
              <g id="prefix__Group_807" data-name="Group 807">
                <path
                  id="prefix__Path_538"
                  data-name="Path 538"
                  className="prefix__cls-7"
                  d="M49 44a14.24 14.24 0 010-1.46.46.46 0 01-.09.17l-.19.23-.28-.13v1.18H48.78z"
                />
              </g>
              <g id="prefix__Group_808" data-name="Group 808">
                <path
                  id="prefix__Path_539"
                  data-name="Path 539"
                  className="prefix__cls-7"
                  d="M76 43h.11v-.09l-.23.05v-.08l-.13.07v.1c0 .05 0 .11-.07.17h.24z"
                />
              </g>
              <g id="prefix__Group_809" data-name="Group 809">
                <path
                  id="prefix__Path_540"
                  data-name="Path 540"
                  className="prefix__cls-7"
                  d="M70 31.89a15.17 15.17 0 00-1.88-1.07.53.53 0 01-.12 0h-.46l-.1-.25v-.12a12.3 12.3 0 00-1.16-.41.39.39 0 01.18.22.37.37 0 010 .23l.21-.09.18.26a.64.64 0 01.08.19 12 12 0 011.42.63h.19v.12l.41.24.18-.09a.45.45 0 01.2 0l.52.11z"
                />
              </g>
              <g id="prefix__Group_810" data-name="Group 810">
                <path
                  id="prefix__Path_541"
                  data-name="Path 541"
                  className="prefix__cls-7"
                  d="M63 30.09v-.08a.44.44 0 01.24-.46 17.61 17.61 0 00-1.78 0l-.06.3a.58.58 0 01-.09.25 13.27 13.27 0 011.69-.01z"
                />
              </g>
              <g id="prefix__Group_811" data-name="Group 811">
                <path
                  id="prefix__Path_542"
                  data-name="Path 542"
                  className="prefix__cls-7"
                  d="M71 33.15a.66.66 0 01.08-.41l-.06-.08c-.22-.19-.46-.37-.7-.54v.16l.06.07.24.36-.23.11c.2.15.4.32.6.49a1.66 1.66 0 01.01-.16z"
                />
              </g>
              <g id="prefix__Group_812" data-name="Group 812">
                <path
                  id="prefix__Path_543"
                  data-name="Path 543"
                  className="prefix__cls-7"
                  d="M66 30q-.42-.12-.87-.21a.75.75 0 01-.3.09h-.43v-.25l-.74-.09.06.06.1.1v.14a.38.38 0 010 .18l.58-.02-.14.21.75.13.08-.05A2.22 2.22 0 0166 30z"
                />
              </g>
              <g id="prefix__Group_813" data-name="Group 813">
                <path
                  id="prefix__Path_544"
                  data-name="Path 544"
                  className="prefix__cls-7"
                  d="M60 30.15a.33.33 0 010 .13l.4-.07-.06-.55-.49.08a.44.44 0 01.15.41z"
                />
              </g>
              <g id="prefix__Group_814" data-name="Group 814">
                <path
                  id="prefix__Path_545"
                  data-name="Path 545"
                  className="prefix__cls-7"
                  d="M76 42v-.26a13.56 13.56 0 00-2-5.65h-.39l.18-.36a14 14 0 00-1-1.37 3.27 3.27 0 01-.62.14A13.26 13.26 0 0175 39.62l.09.08a.54.54 0 01.08.58 12.58 12.58 0 01.27 1.49v.4H75.65a.52.52 0 01.12-.17.78.78 0 01.23 0z"
                />
              </g>
              <g id="prefix__Group_815" data-name="Group 815">
                <path
                  id="prefix__Path_546"
                  data-name="Path 546"
                  className="prefix__cls-7"
                  d="M57.88 56.24l-.24-.49h-.1a.28.28 0 000 .09v.46l.47.16z"
                />
              </g>
              <g id="prefix__Group_816" data-name="Group 816">
                <path
                  id="prefix__Path_547"
                  data-name="Path 547"
                  className="prefix__cls-7"
                  d="M54.85 54.62a.4.4 0 01-.34-.2l-.27.1a14 14 0 002.24 1.32.13.13 0 000-.06v-.2l.15-.14a.42.42 0 01.14-.09 13.84 13.84 0 01-1.55-.86l-.07.13z"
                />
              </g>
              <g id="prefix__Group_817" data-name="Group 817">
                <path
                  id="prefix__Path_548"
                  data-name="Path 548"
                  className="prefix__cls-7"
                  d="M54.68 54.26a.19.19 0 00.12.11v-.07z"
                />
              </g>
              <g id="prefix__Group_818" data-name="Group 818">
                <path
                  id="prefix__Path_549"
                  data-name="Path 549"
                  className="prefix__cls-7"
                  d="M49.69 38.81a.47.47 0 01-.1-.43l.06-.24h.13v-.06h-.26c-.11.26-.21.53-.3.79l.49.27.08-.23z"
                />
              </g>
              <g id="prefix__Group_819" data-name="Group 819">
                <path
                  id="prefix__Path_550"
                  data-name="Path 550"
                  className="prefix__cls-7"
                  d="M49 39.71h.29v-.2l.29.06-.39-.57c-.08.2-.19.45-.19.71z"
                />
              </g>
              <g id="prefix__Group_820" data-name="Group 820">
                <path
                  id="prefix__Path_551"
                  data-name="Path 551"
                  className="prefix__cls-7"
                  d="M49 41.93z"
                />
              </g>
              <g id="prefix__Group_821" data-name="Group 821">
                <path
                  id="prefix__Path_552"
                  data-name="Path 552"
                  className="prefix__cls-7"
                  d="M56.28 31.51v-.08l-.16-.43h.07v-.05l-.6.31a.51.51 0 010 .48l-.08.13V32l-.31.09h-.09a.4.4 0 01-.33-.1.35.35 0 01-.1-.11 4.56 4.56 0 00-.39.27.75.75 0 01.2.37h.24a13 13 0 011.55-1.01z"
                />
              </g>
              <g id="prefix__Group_822" data-name="Group 822">
                <path
                  id="prefix__Path_553"
                  data-name="Path 553"
                  className="prefix__cls-7"
                  d="M73.48 47.08a.4.4 0 00.19 0 .49.49 0 10-.12-1 .49.49 0 00-.43.55.52.52 0 00.36.45z"
                />
              </g>
              <g id="prefix__Group_823" data-name="Group 823">
                <path
                  id="prefix__Path_554"
                  data-name="Path 554"
                  className="prefix__cls-7"
                  d="M72.73 48.55a.43.43 0 01.23.14.46.46 0 01.09.32.5.5 0 00.23-.59.49.49 0 00-.62-.31.48.48 0 00-.29.25v.07h.16a.42.42 0 01.2.12z"
                />
              </g>
              <g id="prefix__Group_824" data-name="Group 824">
                <path
                  id="prefix__Path_555"
                  data-name="Path 555"
                  className="prefix__cls-7"
                  d="M74.52 42.27a.47.47 0 000-.16.17.17 0 000-.07.41.41 0 01-.07.15l-.07.1H74.17a.39.39 0 01-.26 0h-.06a.4.4 0 01-.22-.22l-.08.09v.08a.38.38 0 000 .15.28.28 0 000 .13.78.78 0 01.21 0h.06a.47.47 0 01.37.32.49.49 0 00.33-.57z"
                />
              </g>
              <g id="prefix__Group_825" data-name="Group 825">
                <path
                  id="prefix__Path_556"
                  data-name="Path 556"
                  className="prefix__cls-7"
                  d="M73.55 41.83v-.07a.41.41 0 000 .24l.06-.15-.06-.02z"
                />
              </g>
              <g id="prefix__Group_826" data-name="Group 826">
                <path
                  id="prefix__Path_557"
                  data-name="Path 557"
                  className="prefix__cls-7"
                  d="M74.51 44.53a.53.53 0 00-.1-.35 2.07 2.07 0 01-.5 0h-.2l-.08.08a.41.41 0 01.41.4.32.32 0 010 .14h.4a.58.58 0 00.07-.27z"
                />
              </g>
              <g id="prefix__Group_827" data-name="Group 827">
                <path
                  id="prefix__Path_558"
                  data-name="Path 558"
                  className="prefix__cls-7"
                  d="M73.8 44.47a.19.19 0 00-.13 0z"
                />
              </g>
              <g id="prefix__Group_828" data-name="Group 828">
                <path
                  id="prefix__Path_559"
                  data-name="Path 559"
                  className="prefix__cls-7"
                  d="M73.35 40a.5.5 0 01.43-.43h.15a.46.46 0 00-.39-.2h-.14a.5.5 0 00-.33.62.52.52 0 00.38.34.42.42 0 01-.1-.33z"
                />
              </g>
              <g id="prefix__Group_829" data-name="Group 829">
                <path
                  id="prefix__Path_560"
                  data-name="Path 560"
                  className="prefix__cls-7"
                  d="M66.14 54.05a.51.51 0 000 .45.49.49 0 00.51.31h.12a.48.48 0 00.29-.63.51.51 0 00-.4-.32v.12l-.32.09h-.07a.2.2 0 01-.13-.02z"
                />
              </g>
              <g id="prefix__Group_830" data-name="Group 830">
                <path
                  id="prefix__Path_561"
                  data-name="Path 561"
                  className="prefix__cls-7"
                  d="M52 46.79a.57.57 0 01-.25.08l-.2.1h.34v-.1h.32v-.07h.36l.1-.15-.41.12-.2.06z"
                />
              </g>
              <g id="prefix__Group_831" data-name="Group 831">
                <path
                  id="prefix__Path_562"
                  data-name="Path 562"
                  className="prefix__cls-7"
                  d="M52.84 46.5l.14.06v-.05l.22-.06a.37.37 0 01.23 0h.28V46.91a.28.28 0 00.06-.39.27.27 0 00-.26-.11h-.55z"
                />
              </g>
              <g id="prefix__Group_832" data-name="Group 832">
                <path
                  id="prefix__Path_563"
                  data-name="Path 563"
                  className="prefix__cls-7"
                  d="M51 46.17v.07l.06.3a.43.43 0 010 .16l.08.36h-.36a.48.48 0 00.33.07h.07a.51.51 0 00.23-.15h.12l-.18-.19a.47.47 0 01-.09-.54.58.58 0 00-.26-.08z"
                />
              </g>
              <g id="prefix__Group_833" data-name="Group 833">
                <path
                  id="prefix__Path_564"
                  data-name="Path 564"
                  className="prefix__cls-7"
                  d="M58.13 32H58a.39.39 0 01.1.16z"
                />
              </g>
              <g id="prefix__Group_834" data-name="Group 834">
                <path
                  id="prefix__Path_565"
                  data-name="Path 565"
                  className="prefix__cls-7"
                  d="M57.48 32.74a.51.51 0 00.43.17h.13a.51.51 0 00.31-.47l-.18-.12v.25l-.22.1a.42.42 0 01-.15 0 .69.69 0 01-.32.07z"
                />
              </g>
              <g id="prefix__Group_835" data-name="Group 835">
                <path
                  id="prefix__Path_566"
                  data-name="Path 566"
                  className="prefix__cls-7"
                  d="M69.85 52.38a.5.5 0 00.43.16h.14a.45.45 0 01.23-.22.48.48 0 00-.07-.56.44.44 0 00-.34-.16.49.49 0 00-.49.49.5.5 0 00.12.33z"
                />
              </g>
              <g id="prefix__Group_836" data-name="Group 836">
                <path
                  id="prefix__Path_567"
                  data-name="Path 567"
                  className="prefix__cls-7"
                  d="M50.79 44.89v.08a.47.47 0 00.25-.37.41.41 0 01-.39-.3.57.57 0 01-.37.27v.22a.68.68 0 010 .14z"
                />
              </g>
              <g id="prefix__Group_837" data-name="Group 837">
                <path
                  id="prefix__Path_568"
                  data-name="Path 568"
                  className="prefix__cls-7"
                  d="M72.16 50.53a.49.49 0 00-.18-.47c0 .13.06.27.08.41a.47.47 0 01.1.06z"
                />
              </g>
              <g id="prefix__Group_838" data-name="Group 838">
                <path
                  id="prefix__Path_569"
                  data-name="Path 569"
                  className="prefix__cls-7"
                  d="M68.91 53.09a.5.5 0 00-.42-.23.49.49 0 00-.49.49.53.53 0 00.07.26.51.51 0 00.48.24.5.5 0 00.2-.08l.11-.13a.49.49 0 00.05-.55z"
                />
              </g>
              <g id="prefix__Group_839" data-name="Group 839">
                <path
                  id="prefix__Path_570"
                  data-name="Path 570"
                  className="prefix__cls-7"
                  d="M50.33 42.28l.3-.07a.52.52 0 01.37-.05.48.48 0 00-.42-.3.49.49 0 00-.53.45.45.45 0 01.25-.07v.08z"
                />
              </g>
              <g id="prefix__Group_840" data-name="Group 840">
                <path
                  id="prefix__Path_571"
                  data-name="Path 571"
                  className="prefix__cls-7"
                  d="M53 35.92a.53.53 0 00-.17 0 .94.94 0 010 .16h.1a.32.32 0 01.07-.16z"
                />
              </g>
              <g id="prefix__Group_841" data-name="Group 841">
                <path
                  id="prefix__Path_572"
                  data-name="Path 572"
                  className="prefix__cls-7"
                  d="M55.89 33.52a.76.76 0 01.06.37.49.49 0 00.21-.08.49.49 0 00.18-.62h-.07a1.46 1.46 0 01-.38.33z"
                />
              </g>
              <g id="prefix__Group_842" data-name="Group 842">
                <path
                  id="prefix__Path_573"
                  data-name="Path 573"
                  className="prefix__cls-7"
                  d="M51.31 38z"
                />
              </g>
              <g id="prefix__Group_843" data-name="Group 843">
                <path
                  id="prefix__Path_574"
                  data-name="Path 574"
                  className="prefix__cls-7"
                  d="M51.47 38.31a.14.14 0 00.09-.08h-.11l-.1.09a.16.16 0 00.12-.01z"
                />
              </g>
              <g id="prefix__Group_844" data-name="Group 844">
                <path
                  id="prefix__Path_575"
                  data-name="Path 575"
                  className="prefix__cls-7"
                  d="M51.9 37.77a.55.55 0 00-.4 0 .39.39 0 01.19.12l.18.18-.11.25a.39.39 0 01-.42.21h-.05a.49.49 0 00.18.14.41.41 0 00.27.05.49.49 0 00.43-.55.48.48 0 00-.28-.38z"
                />
              </g>
              <g id="prefix__Group_845" data-name="Group 845">
                <path
                  id="prefix__Path_576"
                  data-name="Path 576"
                  className="prefix__cls-7"
                  d="M50.78 40.72a.61.61 0 00.19 0 .49.49 0 00.42-.35H51a.42.42 0 01-.22.35z"
                />
              </g>
              <g id="prefix__Group_846" data-name="Group 846">
                <path
                  id="prefix__Path_577"
                  data-name="Path 577"
                  className="prefix__cls-7"
                  d="M55.85 53.52l-.14.09a.41.41 0 00.18.19.44.44 0 00.28 0 .49.49 0 00.36-.74l-.15.18a.63.63 0 01-.47.2z"
                />
              </g>
              <g id="prefix__Group_847" data-name="Group 847">
                <path
                  id="prefix__Path_578"
                  data-name="Path 578"
                  className="prefix__cls-7"
                  d="M59.55 31.71a.19.19 0 00-.1 0l.16.06a.15.15 0 00-.06-.06z"
                />
              </g>
              <g id="prefix__Group_848" data-name="Group 848">
                <path
                  id="prefix__Path_579"
                  data-name="Path 579"
                  className="prefix__cls-7"
                  d="M59.76 31.62v-.28a.36.36 0 00-.12.08l.1.13a.18.18 0 01.02.07z"
                />
              </g>
              <g id="prefix__Group_849" data-name="Group 849">
                <path
                  id="prefix__Path_580"
                  data-name="Path 580"
                  className="prefix__cls-7"
                  d="M60 32.28a.49.49 0 00.3-.2h-.51V32a.26.26 0 01-.07.11.3.3 0 01-.08.08.42.42 0 00.33.08z"
                />
              </g>
              <g id="prefix__Group_850" data-name="Group 850">
                <path
                  id="prefix__Path_581"
                  data-name="Path 581"
                  className="prefix__cls-7"
                  d="M53 50.07a.38.38 0 01.09.53.39.39 0 01-.5.1v.13a.49.49 0 00.75-.63.49.49 0 00-.45-.19z"
                />
              </g>
              <g id="prefix__Group_851" data-name="Group 851">
                <path
                  id="prefix__Path_582"
                  data-name="Path 582"
                  className="prefix__cls-7"
                  d="M52 49.12a.49.49 0 10-.71-.37h.12a.57.57 0 01.59.37z"
                />
              </g>
              <g id="prefix__Group_852" data-name="Group 852">
                <path
                  id="prefix__Path_583"
                  data-name="Path 583"
                  className="prefix__cls-7"
                  d="M68.71 33.44a.54.54 0 00.06-.33.44.44 0 01-.09.31l-.06.06v.07z"
                />
              </g>
              <g id="prefix__Group_853" data-name="Group 853">
                <path
                  id="prefix__Path_584"
                  data-name="Path 584"
                  className="prefix__cls-7"
                  d="M66.62 32.14h.18a.11.11 0 000-.07h-.13z"
                />
              </g>
              <g id="prefix__Group_854" data-name="Group 854">
                <path
                  id="prefix__Path_585"
                  data-name="Path 585"
                  className="prefix__cls-7"
                  d="M65.94 32.1h.08z"
                />
              </g>
              <g id="prefix__Group_855" data-name="Group 855">
                <path
                  id="prefix__Path_586"
                  data-name="Path 586"
                  className="prefix__cls-7"
                  d="M64.72 31.64a.5.5 0 00-.4-.41h-.09a.49.49 0 00-.09 1l.12-.29a.44.44 0 01.46-.3z"
                />
              </g>
              <g id="prefix__Group_856" data-name="Group 856">
                <path
                  id="prefix__Path_587"
                  data-name="Path 587"
                  className="prefix__cls-7"
                  d="M69.54 34.49a.5.5 0 00.53.46.48.48 0 00.43-.55.47.47 0 00-.16-.31.5.5 0 00-.7.05.52.52 0 00-.1.35z"
                />
              </g>
              <g id="prefix__Group_857" data-name="Group 857">
                <path
                  id="prefix__Path_588"
                  data-name="Path 588"
                  className="prefix__cls-7"
                  d="M54.5 51.7a.14.14 0 00-.08.09.1.1 0 000 .1z"
                />
              </g>
              <g id="prefix__Group_858" data-name="Group 858">
                <path
                  id="prefix__Path_589"
                  data-name="Path 589"
                  className="prefix__cls-7"
                  d="M71.28 35.78v.06a.65.65 0 010 .31 2 2 0 01.17.36h.11a.49.49 0 00-.11-1h-.08a.45.45 0 01-.1.14z"
                />
              </g>
              <g id="prefix__Group_859" data-name="Group 859">
                <path
                  id="prefix__Path_590"
                  data-name="Path 590"
                  className="prefix__cls-7"
                  d="M62.82 55.11a.5.5 0 00-.5-.49h-.09a.64.64 0 010 .07v.07l-.11.74a.43.43 0 00.25.07h.05a.5.5 0 00.4-.46z"
                />
              </g>
              <g id="prefix__Group_860" data-name="Group 860">
                <path
                  id="prefix__Path_591"
                  data-name="Path 591"
                  className="prefix__cls-7"
                  d="M64 55a.49.49 0 00.54.4.48.48 0 00.39-.57.46.46 0 00-.19-.3l.18.26h-.91v.15L64 55z"
                />
              </g>
              <g id="prefix__Group_861" data-name="Group 861">
                <path
                  id="prefix__Path_592"
                  data-name="Path 592"
                  className="prefix__cls-7"
                  d="M60.26 54.44a.49.49 0 10-.18 1 .38.38 0 00.15 0 .49.49 0 00.43-.54.5.5 0 00-.4-.44z"
                />
              </g>
              <g id="prefix__Group_862" data-name="Group 862">
                <path
                  id="prefix__Path_593"
                  data-name="Path 593"
                  className="prefix__cls-7"
                  d="M73.15 37.6a.54.54 0 00-.14-.16l-.19.06-.16-.14a.5.5 0 00-.41.57.88.88 0 000 .15.51.51 0 00.5.26h.13v-.14h.25a.51.51 0 00.02-.6z"
                />
              </g>
              <g id="prefix__Group_863" data-name="Group 863">
                <path
                  id="prefix__Path_594"
                  data-name="Path 594"
                  className="prefix__cls-7"
                  d="M57.87 54.78a.45.45 0 00.23 0 .5.5 0 00.44-.55.49.49 0 00-.55-.43.49.49 0 00-.16.93z"
                />
              </g>
              <g id="prefix__Group_864" data-name="Group 864">
                <path
                  id="prefix__Path_595"
                  data-name="Path 595"
                  className="prefix__cls-7"
                  d="M57.7 40.44l.07.05.41-.05h-.32a.45.45 0 01-.16 0l-.06.06z"
                />
              </g>
              <g id="prefix__Group_865" data-name="Group 865">
                <path
                  id="prefix__Path_596"
                  data-name="Path 596"
                  className="prefix__cls-7"
                  d="M57.52 39.69h-.08z"
                />
              </g>
              <g id="prefix__Group_866" data-name="Group 866">
                <path
                  id="prefix__Path_597"
                  data-name="Path 597"
                  className="prefix__cls-7"
                  d="M55.4 40.22h1.07v-.08h.22a.44.44 0 01.07-.35.49.49 0 01.22-.18l-1.27.15a.36.36 0 00-.31.46z"
                />
              </g>
              <g id="prefix__Group_867" data-name="Group 867">
                <path
                  id="prefix__Path_598"
                  data-name="Path 598"
                  className="prefix__cls-7"
                  d="M62.49 39.54l.26.14a.56.56 0 01-.1-.29v-.33l-2.4.28a.67.67 0 010 .2v.18l-.14.1a.59.59 0 01-.48.09.48.48 0 01-.21.07h-.21a.93.93 0 01.39.26l2.59-.24.1-.16z"
                />
              </g>
              <g id="prefix__Group_868" data-name="Group 868">
                <path
                  id="prefix__Path_599"
                  data-name="Path 599"
                  className="prefix__cls-7"
                  d="M63.22 39.83h-.08a.39.39 0 01-.21 0l1.29-.15a.45.45 0 01-.16-.2l-.1-.43h.06a.47.47 0 01.06-.19H63.68a.67.67 0 01-.22.65v.06l-.07.11z"
                />
              </g>
              <g id="prefix__Group_869" data-name="Group 869">
                <path
                  id="prefix__Path_600"
                  data-name="Path 600"
                  className="prefix__cls-7"
                  d="M68.89 43.83l-.6-5.07a.38.38 0 00-.41-.33l-1.88.23v.06a.37.37 0 01-.5.08.26.26 0 01-.09-.09l-.53.06a.67.67 0 01.2.39l.07.35-.28.07 1.76-.21-2.16 2.05a1.81 1.81 0 01.41.37l3-2.83.59 5h.18a.77.77 0 01.24-.13z"
                />
              </g>
              <g id="prefix__Group_870" data-name="Group 870">
                <path
                  id="prefix__Path_601"
                  data-name="Path 601"
                  className="prefix__cls-7"
                  d="M57.65 41.28z"
                />
              </g>
              <g id="prefix__Group_871" data-name="Group 871">
                <path
                  id="prefix__Path_602"
                  data-name="Path 602"
                  className="prefix__cls-7"
                  d="M56.05 41.82v-.14h-.1a.54.54 0 01-.28 0h-.09v.31a.65.65 0 01.47-.17z"
                />
              </g>
              <g id="prefix__Group_872" data-name="Group 872">
                <path
                  id="prefix__Path_603"
                  data-name="Path 603"
                  className="prefix__cls-7"
                  d="M56.5 44.89h-.06V45h.06z"
                />
              </g>
              <g id="prefix__Group_873" data-name="Group 873">
                <path
                  id="prefix__Path_604"
                  data-name="Path 604"
                  className="prefix__cls-7"
                  d="M55.84 43.33l-.08.05.13 1a.46.46 0 01.2.05.65.65 0 010-.2.51.51 0 01.26-.26l-.08-.67a.84.84 0 01-.43.03z"
                />
              </g>
              <g id="prefix__Group_874" data-name="Group 874">
                <path
                  id="prefix__Path_605"
                  data-name="Path 605"
                  className="prefix__cls-7"
                  d="M68.57 45.17v.14a1 1 0 01.29-.07v-.14a.77.77 0 01-.12-.28h-.29v.32z"
                />
              </g>
              <g id="prefix__Group_875" data-name="Group 875">
                <path
                  id="prefix__Path_606"
                  data-name="Path 606"
                  className="prefix__cls-7"
                  d="M64.09 47.05l-.09-.31a1 1 0 010-.17l-1.52.18.05.21a.75.75 0 01-.08.53h.1l.17-.18v.15l6.11-.72a.38.38 0 00.33-.42v-.22a1.41 1.41 0 01-.54.11h-.25l-.07-.17-.3-.12a1 1 0 01-.48 0l-.28-.07v-.3a.17.17 0 000-.07H67.09l-.42.22.71.41-1.88.23a.64.64 0 01-.46.24h-.09a.37.37 0 01-.08.18.57.57 0 01-.36.2z"
                />
              </g>
              <g id="prefix__Group_876" data-name="Group 876">
                <path
                  id="prefix__Path_607"
                  data-name="Path 607"
                  className="prefix__cls-7"
                  d="M62.92 43.64l2.79 1.61a.5.5 0 01.75.17v-.23a.61.61 0 010-.13l-3.16-1.82.78-.74a2.47 2.47 0 01-.6-.19l-1.2 1.14-1.63-.93.34.76-.65-.77h-.12a.56.56 0 01-.3-.12.5.5 0 01-.2-.29.54.54 0 01-.1-.16l-1.74-1-.1.11a.38.38 0 01.23.11h.18l.12.1a.52.52 0 01.18.41v.25l1.29.74a.4.4 0 01.37.22l1.12.64-1.2 1.15a.33.33 0 010 .14.41.41 0 01-.37.35h-.15l-1 .95a1.12 1.12 0 01.46.17l.09.07 1.84-1.75-.06-.18a.54.54 0 01.15-.57l.16-.17.23.06a.43.43 0 01.24.18l.11-.11.63.36z"
                />
              </g>
              <g id="prefix__Group_877" data-name="Group 877">
                <path
                  id="prefix__Path_608"
                  data-name="Path 608"
                  className="prefix__cls-7"
                  d="M57.41 48l.13.1 2.46-.25a.27.27 0 010-.12l-.07-.58.45.14a.65.65 0 01.53 0l.18.09v.2a.43.43 0 010 .16l.67-.08a.5.5 0 01-.12-.33.74.74 0 01.22-.48l-3.74.45.22-.21-.24-.09a.57.57 0 01-.3-.23l-1 .91-.17-1.68-.16-.1-.15.33-.25-.23.24 2a.36.36 0 00.2.29v-.15h.37L57 48a.46.46 0 01.41 0z"
                />
              </g>
              <g id="prefix__Group_878" data-name="Group 878">
                <path
                  id="prefix__Path_609"
                  data-name="Path 609"
                  className="prefix__cls-7"
                  d="M46.83 33.68s0-.1-.09-.16h-.15v.47h.14a.53.53 0 01.1-.31z"
                />
              </g>
              <g id="prefix__Group_879" data-name="Group 879">
                <path
                  id="prefix__Path_610"
                  data-name="Path 610"
                  className="prefix__cls-7"
                  d="M44.28 33.44l.06.05 1.39-.62a1.3 1.3 0 00-1.11.35v.05l-.13-.08-.12.22z"
                />
              </g>
              <g id="prefix__Group_880" data-name="Group 880">
                <path
                  id="prefix__Path_611"
                  data-name="Path 611"
                  className="prefix__cls-7"
                  d="M45.2 36.1z"
                />
              </g>
              <g id="prefix__Group_881" data-name="Group 881">
                <path
                  id="prefix__Path_612"
                  data-name="Path 612"
                  className="prefix__cls-7"
                  d="M44.7 36.1l.4-.05a5.37 5.37 0 01-1.16-.86h-.48l-.1.21z"
                />
              </g>
              <g id="prefix__Group_882" data-name="Group 882">
                <path
                  id="prefix__Path_613"
                  data-name="Path 613"
                  className="prefix__cls-7"
                  d="M46.3 36.63a1.41 1.41 0 01-.42-.22.38.38 0 01-.17.08.37.37 0 010 .11l1.25.62.19-.38h-.23a.47.47 0 01-.31.11h-.17l-.11-.13a.42.42 0 01-.03-.19z"
                />
              </g>
              <g id="prefix__Group_883" data-name="Group 883">
                <path
                  id="prefix__Path_614"
                  data-name="Path 614"
                  className="prefix__cls-7"
                  d="M44.53 34.16l-.2.14.08.08.12-.23z"
                />
              </g>
              <g id="prefix__Group_884" data-name="Group 884">
                <path
                  id="prefix__Path_615"
                  data-name="Path 615"
                  className="prefix__cls-7"
                  d="M45.58 36.3a.16.16 0 00.1 0l-.21-.07a.16.16 0 00.11.07z"
                />
              </g>
              <g id="prefix__Group_885" data-name="Group 885">
                <path
                  id="prefix__Path_616"
                  data-name="Path 616"
                  className="prefix__cls-7"
                  d="M48 32.69a.41.41 0 01.15.4.58.58 0 010 .14 2 2 0 00.84 0 .67.67 0 01.53-.4v-.1h-.22v-.23a1.43 1.43 0 01-1 .17.52.52 0 01-.16.06z"
                />
              </g>
              <g id="prefix__Group_886" data-name="Group 886">
                <path
                  id="prefix__Path_617"
                  data-name="Path 617"
                  className="prefix__cls-7"
                  d="M46.9 31l-.14.05h-.11l-.32.3a2 2 0 00.06.26.55.55 0 01.38 0l.26.07v.27a.61.61 0 01-.1.45l.25.14a.49.49 0 01.17.18l.08-.4.17.1a.29.29 0 010-.1.61.61 0 01-.16-.12 1.54 1.54 0 01-.54-1.2z"
                />
              </g>
              <g id="prefix__Group_887" data-name="Group 887">
                <path
                  id="prefix__Path_618"
                  data-name="Path 618"
                  className="prefix__cls-7"
                  d="M49.05 29.55s0-.01 0 0z"
                />
              </g>
              <g id="prefix__Group_888" data-name="Group 888">
                <path
                  id="prefix__Path_619"
                  data-name="Path 619"
                  className="prefix__cls-7"
                  d="M50.46 27.86a.6.6 0 01-.11-.34l-.2-.07v.1l-.23.05h-.11a1.07 1.07 0 00.2.63 1 1 0 00.33.31.93.93 0 01.29-.05l.5-.45a.58.58 0 01-.67-.18z"
                />
              </g>
              <g id="prefix__Group_889" data-name="Group 889">
                <path
                  id="prefix__Path_620"
                  data-name="Path 620"
                  className="prefix__cls-7"
                  d="M53.76 28.22a1 1 0 00-.14-.28c-.47-.67-1.18-.39-1.86-.11-.13 0-.25.1-.37.13l-.07.28a.85.85 0 01.3-.15L52 28l.05.24h.07v-.2l.26.14a.93.93 0 01.23 0v-.23l.65.35z"
                />
              </g>
              <g id="prefix__Group_890" data-name="Group 890">
                <path
                  id="prefix__Path_621"
                  data-name="Path 621"
                  className="prefix__cls-7"
                  d="M53.63 28.46h.18a.85.85 0 000-.22z"
                />
              </g>
              <g id="prefix__Group_891" data-name="Group 891">
                <path
                  id="prefix__Path_622"
                  data-name="Path 622"
                  className="prefix__cls-7"
                  d="M51.38 26.07l-.43.64a2.52 2.52 0 011.05-.39l-.11-.48a2.68 2.68 0 00-1.27.49l-.2.15z"
                />
              </g>
              <g id="prefix__Group_892" data-name="Group 892">
                <path
                  id="prefix__Path_623"
                  data-name="Path 623"
                  className="prefix__cls-7"
                  d="M53.49 29.38l-.49-.24a2.17 2.17 0 01-.36.32 2.6 2.6 0 01-1.37.45l.1.49a2.79 2.79 0 001.63-.54 2.43 2.43 0 00.49-.48z"
                />
              </g>
              <g id="prefix__Group_893" data-name="Group 893">
                <path
                  id="prefix__Path_624"
                  data-name="Path 624"
                  className="prefix__cls-7"
                  d="M53.52 29.34l.08-.12a.27.27 0 01-.08-.07z"
                />
              </g>
              <g id="prefix__Group_894" data-name="Group 894">
                <path
                  id="prefix__Path_625"
                  data-name="Path 625"
                  className="prefix__cls-7"
                  d="M53.09 25.28a.75.75 0 01-.5-.16l-.17.07.2.46 1.3-.57 1.47 3.3.57-.26-1.46-3.3.75-.33a1.17 1.17 0 01-.1-.41V24l-1.64.72a.49.49 0 01-.22.5.5.5 0 01-.2.06z"
                />
              </g>
              <g id="prefix__Group_895" data-name="Group 895">
                <path
                  id="prefix__Path_626"
                  data-name="Path 626"
                  className="prefix__cls-7"
                  d="M58.3 25.77a.19.19 0 000 .07v.06-.26h.24a.21.21 0 00-.13 0 .18.18 0 00-.11.13z"
                />
              </g>
              <g id="prefix__Group_896" data-name="Group 896">
                <path
                  id="prefix__Path_627"
                  data-name="Path 627"
                  className="prefix__cls-7"
                  d="M58.33 24.18h-.09a2.23 2.23 0 00-.12 1 1.7 1.7 0 000 .22h.31a.41.41 0 01.06.81 2.1 2.1 0 001.42.82l.48-.06V27h.33a.52.52 0 01.06-.34l.09-.17h.16a.67.67 0 01.37-.15h.3l.07.22a1.29 1.29 0 00.17-.16.51.51 0 01.22-.48.47.47 0 01.15-.06 1.76 1.76 0 00.15-.44h-.62a1.6 1.6 0 01-3.13-.25 1.56 1.56 0 011.32-1.74h.09a1.54 1.54 0 011.68 1.07h.66a2.1 2.1 0 00-2.39-1.62h-.14l-.11.2-.07-.17a2.29 2.29 0 00-1.13.64.77.77 0 010 .37v.25l-.25.05z"
                />
              </g>
              <g id="prefix__Group_897" data-name="Group 897">
                <path
                  id="prefix__Path_628"
                  data-name="Path 628"
                  className="prefix__cls-7"
                  d="M66.36 23.17l-.1-.07-1.26-.17.22.17.14.1.3-.05v.09a.41.41 0 01.29.16.53.53 0 01.08.17l.59.08v-.4a.46.46 0 01-.26-.08z"
                />
              </g>
              <g id="prefix__Group_898" data-name="Group 898">
                <path
                  id="prefix__Path_629"
                  data-name="Path 629"
                  className="prefix__cls-7"
                  d="M64 25.85a.53.53 0 010-.35v-.2h.1a.54.54 0 01.43 0h.2v-.08l.32-.09s0-.05.06-.07v-.08l-1.09-.15.16-1.13-.08-.21a.5.5 0 01.15-.59l-.57-.08-.22 1.65h.37l.1.8-.59.06v.21a.52.52 0 01.19.12.59.59 0 01.13.51v.16l-.13.09a.5.5 0 01-.29.09v.39l.61.09z"
                />
              </g>
              <g id="prefix__Group_899" data-name="Group 899">
                <path
                  id="prefix__Path_630"
                  data-name="Path 630"
                  className="prefix__cls-7"
                  d="M66 25.53h.08v-.14z"
                />
              </g>
              <g id="prefix__Group_900" data-name="Group 900">
                <path
                  id="prefix__Path_631"
                  data-name="Path 631"
                  className="prefix__cls-7"
                  d="M69.19 24.49l.49.17a.64.64 0 01.65-.24h.11L69.27 24a.71.71 0 010 .25.77.77 0 01-.08.24z"
                />
              </g>
              <g id="prefix__Group_901" data-name="Group 901">
                <path
                  id="prefix__Path_632"
                  data-name="Path 632"
                  className="prefix__cls-7"
                  d="M70.59 24.56v-.12l-.14-.05z"
                />
              </g>
              <g id="prefix__Group_903" data-name="Group 903">
                <path
                  id="prefix__Path_634"
                  data-name="Path 634"
                  className="prefix__cls-7"
                  d="M67.94 23.51h-.07l-.07.18a.54.54 0 01.14-.18z"
                />
              </g>
              <g id="prefix__Group_905" data-name="Group 905">
                <path
                  id="prefix__Path_636"
                  data-name="Path 636"
                  className="prefix__cls-7"
                  d="M66.75 26.61l-.26.75.59.21.55-1.57 1.07.38a.39.39 0 01-.16-.1h-.05a.51.51 0 01-.33-.5v-.09l-.36-.12.28-.79-.08-.06h-.1a.5.5 0 01-.16.4l-.14.14a.62.62 0 01-.17.22.53.53 0 010 .35l.08.34h-.13a.28.28 0 010 .09v.28h-.29a.52.52 0 01-.34.07z"
                />
              </g>
              <g id="prefix__Group_906" data-name="Group 906">
                <path
                  id="prefix__Path_637"
                  data-name="Path 637"
                  className="prefix__cls-7"
                  d="M69.55 26.17v.15a.39.39 0 01-.09.33h.07l.17-.48z"
                />
              </g>
              <g id="prefix__Group_907" data-name="Group 907">
                <path
                  id="prefix__Path_638"
                  data-name="Path 638"
                  className="prefix__cls-7"
                  d="M70.41 27.14l-.79 1.49.55.29 1-1.86z"
                />
              </g>
              <g id="prefix__Group_908" data-name="Group 908">
                <path
                  id="prefix__Path_639"
                  data-name="Path 639"
                  className="prefix__cls-7"
                  d="M71.24 26.22l-.06.5v.23l.91-1.69-.55-.3-.69 1.29z"
                />
              </g>
              <g id="prefix__Group_909" data-name="Group 909">
                <path
                  id="prefix__Path_640"
                  data-name="Path 640"
                  className="prefix__cls-7"
                  d="M75.12 28.09a2 2 0 01.17.53l.53-.05a2 2 0 00-.67-1.29l-.06.53.19-.08z"
                />
              </g>
              <g id="prefix__Group_910" data-name="Group 910">
                <path
                  id="prefix__Path_641"
                  data-name="Path 641"
                  className="prefix__cls-7"
                  d="M74.46 27l-.3-.3a1.93 1.93 0 00-.63-.1 2.06 2.06 0 00-1.65.83 2.31 2.31 0 00-.28.48h.1a.44.44 0 01.37-.21h.3v.11a1.54 1.54 0 011.4-.61h.29v.1a1.83 1.83 0 01.53.29 1.52 1.52 0 01.31.31l-.34-.71a.57.57 0 01-.1-.19z"
                />
              </g>
              <g id="prefix__Group_911" data-name="Group 911">
                <path
                  id="prefix__Path_642"
                  data-name="Path 642"
                  className="prefix__cls-7"
                  d="M73.45 30.7a1.51 1.51 0 01-.11.22 1.88 1.88 0 00.67 0l-.01-.27h-.3a.74.74 0 01-.25.05z"
                />
              </g>
              <g id="prefix__Group_912" data-name="Group 912">
                <path
                  id="prefix__Path_643"
                  data-name="Path 643"
                  className="prefix__cls-7"
                  d="M72.05 28.59z"
                />
              </g>
              <g id="prefix__Group_913" data-name="Group 913">
                <path
                  id="prefix__Path_644"
                  data-name="Path 644"
                  className="prefix__cls-7"
                  d="M72.17 29.36l-.17-.11v-.14a.51.51 0 010-.42h-.16v.17h-.37a2.21 2.21 0 00.32.9l.08-.09a.51.51 0 01.38-.2z"
                />
              </g>
              <g id="prefix__Group_914" data-name="Group 914">
                <path
                  id="prefix__Path_645"
                  data-name="Path 645"
                  className="prefix__cls-7"
                  d="M77.87 30.15a.38.38 0 01-.29-.2.39.39 0 010-.24l-.09-.19-.36-.44-.64.53h.33l.06.52.26-.21 1.18 1.44a1.46 1.46 0 01.48-.21l-.8-.98z"
                />
              </g>
              <g id="prefix__Group_915" data-name="Group 915">
                <path
                  id="prefix__Path_646"
                  data-name="Path 646"
                  className="prefix__cls-7"
                  d="M75.86 33.41l.13.18-.09.2.12.1.21-.18-1.53-1.87.39-.32a1.36 1.36 0 01-.68-.24l-.49.4.07.08h.09a.4.4 0 01.45.16.42.42 0 010 .43.36.36 0 010 .11l.56.68.22.1h.05a.57.57 0 01.5.17z"
                />
              </g>
              <g id="prefix__Group_917" data-name="Group 917">
                <path
                  id="prefix__Path_648"
                  data-name="Path 648"
                  className="prefix__cls-7"
                  d="M76 30l-.19.15h.17v.16l-.05.16-.27-.08.11.07a.87.87 0 01.36.7.19.19 0 000 .08l.06.36h-.08l.85 1 .38-.31-1.24-1.6.29-.23h-.3z"
                />
              </g>
              <g id="prefix__Group_918" data-name="Group 918">
                <path
                  id="prefix__Path_649"
                  data-name="Path 649"
                  className="prefix__cls-7"
                  d="M50.29 58.43z"
                />
              </g>
              <g id="prefix__Group_919" data-name="Group 919">
                <path
                  id="prefix__Path_650"
                  data-name="Path 650"
                  className="prefix__cls-7"
                  d="M55.17 60.15a.33.33 0 01.17-.14v-.06a.57.57 0 01.39-.38 1.3 1.3 0 01.78.06 2.28 2.28 0 01.45.2h.2a.59.59 0 01.14.06l.29.16h.14l.37-.05v.18l1.08.15L59 62a.66.66 0 01.06.2v.34h-.15v.25a.17.17 0 010 .1l.07.28h-.12l-.09.67.61.08.5-3.55 1.4.2.07-.49-3.41-.48v.21l-.12-.11a2.77 2.77 0 00-1-.57c-1.15-.36-1.74.09-1.91.64a1.27 1.27 0 00-.06.28.56.56 0 01.42.08z"
                />
              </g>
              <g id="prefix__Group_920" data-name="Group 920">
                <path
                  id="prefix__Path_651"
                  data-name="Path 651"
                  className="prefix__cls-7"
                  d="M55.47 60.56z"
                />
              </g>
              <g id="prefix__Group_921" data-name="Group 921">
                <path
                  id="prefix__Path_652"
                  data-name="Path 652"
                  className="prefix__cls-7"
                  d="M65.7 63.48z"
                />
              </g>
              <g id="prefix__Group_922" data-name="Group 922">
                <path
                  id="prefix__Path_653"
                  data-name="Path 653"
                  className="prefix__cls-7"
                  d="M66.74 62.05a.44.44 0 01.22-.28 1 1 0 000-.16 2.56 2.56 0 000-.27h-.11l-.5.06a1.18 1.18 0 010 .2 1.53 1.53 0 01-1.27 1.76h-.09a1.54 1.54 0 01-1.76-1.26.37.37 0 010-.11 1.54 1.54 0 011.26-1.76h.1a1.57 1.57 0 011.36.47v-.12l.64-.07a2.1 2.1 0 00-1.72-.82h-.34a2.1 2.1 0 00-1.93 2.24.78.78 0 000 .14 2.05 2.05 0 00.81 1.41A2.25 2.25 0 0065 64a1.61 1.61 0 00.38-.08v-.24a.38.38 0 01.36-.42h.06a.53.53 0 01.49-.23h.33a2.12 2.12 0 00.23-.48.46.46 0 01-.11-.5z"
                />
              </g>
              <g id="prefix__Group_923" data-name="Group 923">
                <path
                  id="prefix__Path_654"
                  data-name="Path 654"
                  className="prefix__cls-7"
                  d="M70.16 60.37h-.07l.15.2z"
                />
              </g>
              <g id="prefix__Group_924" data-name="Group 924">
                <path
                  id="prefix__Path_655"
                  data-name="Path 655"
                  className="prefix__cls-7"
                  d="M69.36 58.82l.06-.1a.44.44 0 01-.27-.07l-1 .36a.58.58 0 01-.09.25l-.09.34 1.36-.48v-.11h.09-.08v-.13z"
                />
              </g>
              <g id="prefix__Group_925" data-name="Group 925">
                <path
                  id="prefix__Path_656"
                  data-name="Path 656"
                  className="prefix__cls-7"
                  d="M67.35 59.8a.81.81 0 01.4-.07v-.06l-.32-.22a.57.57 0 01-.13-.14l-.34.12.13.38h.23v.08z"
                />
              </g>
              <g id="prefix__Group_926" data-name="Group 926">
                <path
                  id="prefix__Path_657"
                  data-name="Path 657"
                  className="prefix__cls-7"
                  d="M68.28 61l.2.17a.43.43 0 01.14.23h.08a.37.37 0 01.37-.37.38.38 0 01.28.14l.22-.08a.33.33 0 010-.17l-.15-.1a.25.25 0 00-.22-.12l-.83.3v.08V61z"
                />
              </g>
              <g id="prefix__Group_927" data-name="Group 927">
                <path
                  id="prefix__Path_658"
                  data-name="Path 658"
                  className="prefix__cls-7"
                  d="M68.32 62.08l-.15.07-.17-.08a.41.41 0 01-.1-.07l.34 1h.28a.39.39 0 01.25.12l.16-.06-.4-1.14a.42.42 0 01-.21.16z"
                />
              </g>
              <g id="prefix__Group_928" data-name="Group 928">
                <path
                  id="prefix__Path_659"
                  data-name="Path 659"
                  className="prefix__cls-7"
                  d="M67.89 61.19v-.16l-.17-.03a.37.37 0 01-.25-.21l.2.55z"
                />
              </g>
              <g id="prefix__Group_929" data-name="Group 929">
                <path
                  id="prefix__Path_660"
                  data-name="Path 660"
                  className="prefix__cls-7"
                  d="M73.56 59.09l-.25-.44-.33.19a.51.51 0 01-.06.48.4.4 0 01-.27.14.5.5 0 01-.17 0l-.18-.06v-.13l-.44.25.27.42z"
                />
              </g>
              <g id="prefix__Group_930" data-name="Group 930">
                <path
                  id="prefix__Path_661"
                  data-name="Path 661"
                  className="prefix__cls-7"
                  d="M71.9 61.57l.14.26.54-.31-.12-.22h-.08z"
                />
              </g>
              <g id="prefix__Group_931" data-name="Group 931">
                <path
                  id="prefix__Path_662"
                  data-name="Path 662"
                  className="prefix__cls-7"
                  d="M71.83 61.27l-.14-.07.16.28z"
                />
              </g>
              <g id="prefix__Group_932" data-name="Group 932">
                <path
                  id="prefix__Path_663"
                  data-name="Path 663"
                  className="prefix__cls-7"
                  d="M70.94 57.75l-.4.23V58h.28l.1.2.33-.19-.13-.01a.44.44 0 01-.18-.25z"
                />
              </g>
              <g id="prefix__Group_933" data-name="Group 933">
                <path
                  id="prefix__Path_664"
                  data-name="Path 664"
                  className="prefix__cls-7"
                  d="M71.53 59.67l-.1-.17-.42.1v-.44a.68.68 0 01.06-.34l-.07-.14a.44.44 0 01-.59.22l1.16 2a.46.46 0 010-.26l.08-.23h.1l-.15-.81z"
                />
              </g>
              <g id="prefix__Group_934" data-name="Group 934">
                <path
                  id="prefix__Path_665"
                  data-name="Path 665"
                  className="prefix__cls-7"
                  d="M71.67 57.87l.63-.35.08-.34.17.19.28-.16-.24-.43-.39.22a.5.5 0 010 .21.44.44 0 01-.32.34v.12a.64.64 0 01-.21.2z"
                />
              </g>
              <g id="prefix__Group_935" data-name="Group 935">
                <path
                  id="prefix__Path_666"
                  data-name="Path 666"
                  className="prefix__cls-7"
                  d="M72.51 59.11z"
                />
              </g>
              <g id="prefix__Group_936" data-name="Group 936">
                <path
                  id="prefix__Path_667"
                  data-name="Path 667"
                  className="prefix__cls-7"
                  d="M71.79 61z"
                />
              </g>
              <g id="prefix__Group_937" data-name="Group 937">
                <path
                  id="prefix__Path_668"
                  data-name="Path 668"
                  className="prefix__cls-7"
                  d="M73.62 56.79a.39.39 0 01-.4-.37.43.43 0 01.06-.22l-.45.34 2.47 3.26.5-.37-2-2.63a.29.29 0 01-.16 0z"
                />
              </g>
              <g id="prefix__Group_938" data-name="Group 938">
                <path
                  id="prefix__Path_669"
                  data-name="Path 669"
                  className="prefix__cls-7"
                  d="M78 57.15v-.32l-.08.1a1.55 1.55 0 01-2.18.1l-.12-.03a1.77 1.77 0 01-.36-.53l-.67-.08a2.12 2.12 0 00.59 1 2.06 2.06 0 002.93 0 .65.65 0 01-.11-.24z"
                />
              </g>
              <g id="prefix__Group_939" data-name="Group 939">
                <path
                  id="prefix__Path_670"
                  data-name="Path 670"
                  className="prefix__cls-7"
                  d="M74.55 55.9a2.62 2.62 0 000 .28l.6-.1a1.65 1.65 0 011.43-1.85h.17v-.53a2.11 2.11 0 00-1.49.67 2.26 2.26 0 00-.71 1.53z"
                />
              </g>
              <g id="prefix__Group_940" data-name="Group 940">
                <path
                  id="prefix__Path_671"
                  data-name="Path 671"
                  className="prefix__cls-7"
                  d="M78.64 56.76a1.89 1.89 0 00.24-1h-.41l-.13.12a1.47 1.47 0 01-.27.79h.33a.43.43 0 01.24.09z"
                />
              </g>
              <g id="prefix__Group_941" data-name="Group 941">
                <path
                  id="prefix__Path_672"
                  data-name="Path 672"
                  className="prefix__cls-7"
                  d="M78.75 53.74L79.89 52l-.4-.27-1.14 1.71-1.06-.7 1.28-1.93-.41-.27L76.54 53l3.4 2.25 1.67-2.52-.41-.27-1.33 2z"
                />
              </g>
              <g id="prefix__Group_942" data-name="Group 942">
                <path
                  id="prefix__Path_673"
                  data-name="Path 673"
                  className="prefix__cls-7"
                  d="M12.06 30h-.29a.31.31 0 01-.23 0h-.06a.84.84 0 00-.48 0 8 8 0 011.2.1.4.4 0 01-.14-.1z"
                />
              </g>
              <g id="prefix__Group_943" data-name="Group 943">
                <path
                  id="prefix__Path_674"
                  data-name="Path 674"
                  className="prefix__cls-7"
                  d="M14.48 30.25l-.06.3-.31-.06a.38.38 0 01-.3-.15l-.07-.09v-.1a.35.35 0 01.06-.15l-.38-.13a.58.58 0 01.11.46v.15a9.43 9.43 0 011.75.85h.1v.08a.33.33 0 01.29.13v.08l1 .64.43.3a.29.29 0 01.16 0 .47.47 0 01.14-.45l-.4-.35a17.67 17.67 0 00-2.52-1.51z"
                />
              </g>
              <g id="prefix__Group_944" data-name="Group 944">
                <path
                  id="prefix__Path_675"
                  data-name="Path 675"
                  className="prefix__cls-7"
                  d="M18.51 32.76h-.06v.05z"
                />
              </g>
              <g id="prefix__Group_945" data-name="Group 945">
                <path
                  id="prefix__Path_676"
                  data-name="Path 676"
                  className="prefix__cls-7"
                  d="M17.54 32.8c.27.18.55.35.85.53a1.08 1.08 0 010-.18v-.06l-.05-.3h-.06a.53.53 0 01-.5-.12h-.25a.06.06 0 00.01.13z"
                />
              </g>
              <g id="prefix__Group_946" data-name="Group 946">
                <path
                  id="prefix__Path_677"
                  data-name="Path 677"
                  className="prefix__cls-7"
                  d="M19.79 33.39l-.17.07-.1-.18c-.15-.06-.3-.14-.46-.22a1.08 1.08 0 010 .31v.3a8.69 8.69 0 005.07.78h.06a.53.53 0 010-.53h-.1a8.29 8.29 0 01-4.3-.53z"
                />
              </g>
              <g id="prefix__Group_947" data-name="Group 947">
                <path
                  id="prefix__Path_678"
                  data-name="Path 678"
                  className="prefix__cls-7"
                  d="M1.38 34.93h.24a.42.42 0 01.31.22c.46-.44.88-.9 1.28-1.34A19.22 19.22 0 015 32v-.18h.24a7.74 7.74 0 012.7-1.4.37.37 0 01-.17-.18.36.36 0 010-.35 8.46 8.46 0 00-.8.28.3.3 0 01-.09.13.35.35 0 01-.38.07 9.13 9.13 0 00-2.21 1.53.3.3 0 01-.14.27.24.24 0 01-.13 0H4c-.23.23-.46.47-.75.79a.49.49 0 01-.25.24l-.21.23c-.46.57-.92 1.04-1.41 1.5z"
                />
              </g>
              <g id="prefix__Group_948" data-name="Group 948">
                <path
                  id="prefix__Path_679"
                  data-name="Path 679"
                  className="prefix__cls-7"
                  d="M9.28 29.77v-.21a10.05 10.05 0 00-1.07.2.37.37 0 01.16.3l.07.19.76-.14h-.26z"
                />
              </g>
              <g id="prefix__Group_949" data-name="Group 949">
                <path
                  id="prefix__Path_680"
                  data-name="Path 680"
                  className="prefix__cls-7"
                  d="M1.43 35.62h-.05a.43.43 0 01-.09-.39V35A8.76 8.76 0 010 36l.07.6a8.69 8.69 0 001.36-.98z"
                />
              </g>
              <g id="prefix__Group_950" data-name="Group 950">
                <path
                  id="prefix__Path_681"
                  data-name="Path 681"
                  className="prefix__cls-7"
                  d="M44 28.19a.51.51 0 01.15.07h.33c.39-.45.79-.88 1.2-1.31l-.24.06h-.08a.59.59 0 01-.32-.06l-.04-.02-.32.34.09.2a.43.43 0 01-.11.55l-.08.11h-.2a.41.41 0 01-.32-.15L44 28v.09a.56.56 0 010 .1z"
                />
              </g>
              <g id="prefix__Group_951" data-name="Group 951">
                <path
                  id="prefix__Path_682"
                  data-name="Path 682"
                  className="prefix__cls-7"
                  d="M44.94 29.28a.42.42 0 01.14-.09.66.66 0 01.17-.29l-.63-.43-.11-.07-.06.31a.57.57 0 01-.11.22l.14.1a.61.61 0 01.46.25z"
                />
              </g>
              <g id="prefix__Group_952" data-name="Group 952">
                <path
                  id="prefix__Path_683"
                  data-name="Path 683"
                  className="prefix__cls-7"
                  d="M46.21 26.33l-.08-.33a.6.6 0 010-.23l-.51.49a.43.43 0 01.15.28l.07.28c.19-.19.37-.37.56-.54z"
                />
              </g>
              <g id="prefix__Group_953" data-name="Group 953">
                <path
                  id="prefix__Path_684"
                  data-name="Path 684"
                  className="prefix__cls-7"
                  d="M48.66 30.5a7.84 7.84 0 01-1.27-.41l-.12-.09.09-.09a1.37 1.37 0 01.29-.24l-.27-.47a3.62 3.62 0 00-.42.36l.06.06-.18.28-.06.08a1.12 1.12 0 01.1.22H47l.87.12-.42.33a7.92 7.92 0 00.78.26h.23a.7.7 0 01.25 0 .36.36 0 010-.25z"
                />
              </g>
              <g id="prefix__Group_954" data-name="Group 954">
                <path
                  id="prefix__Path_685"
                  data-name="Path 685"
                  className="prefix__cls-7"
                  d="M51.7 30.62c-.32 0-.64.06-1 .07h-.07v-.07a2.16 2.16 0 00-.7-1.24 2.06 2.06 0 00-2.2-.36v.63a1.45 1.45 0 011-.18l.06-.1v-.29l.37.06a.45.45 0 01.27.71 1.58 1.58 0 01.48.71v.12H50h-.46a.65.65 0 01.11.22l.08.36H50.15v.1a1.8 1.8 0 01-.1.33l.29-.05v.54a2.31 2.31 0 00.38-.9v-.07h.07a9.1 9.1 0 001-.08.27.27 0 00-.07-.54z"
                />
              </g>
              <g id="prefix__Group_955" data-name="Group 955">
                <path
                  id="prefix__Path_686"
                  data-name="Path 686"
                  className="prefix__cls-7"
                  d="M39.74 26.49h.05z"
                />
              </g>
              <g id="prefix__Group_956" data-name="Group 956">
                <path
                  id="prefix__Path_687"
                  data-name="Path 687"
                  className="prefix__cls-7"
                  d="M38.24 26.57v.14h.86l.18-.5a8.7 8.7 0 00-1 0 .53.53 0 01-.04.36z"
                />
              </g>
              <g id="prefix__Group_957" data-name="Group 957">
                <path
                  id="prefix__Path_688"
                  data-name="Path 688"
                  className="prefix__cls-7"
                  d="M39.73 26.8v-.07h-.28z"
                />
              </g>
              <g id="prefix__Group_958" data-name="Group 958">
                <path
                  id="prefix__Path_689"
                  data-name="Path 689"
                  className="prefix__cls-7"
                  d="M29.89 31.57a.47.47 0 010-.51.7.7 0 01.6-.27h.14l.23-.25.58-.64a.39.39 0 01-.19-.51v-.08l.08-.1.5-.06v.28a8.52 8.52 0 013.44-2.22.5.5 0 01.15-.45.48.48 0 01.55-.09.61.61 0 01.29.28c.29-.06.6-.11.9-.15h.17l.06-.15a.44.44 0 01-.12-.4h-.18c-3.55.43-5.16 2.2-6.72 3.93a21.41 21.41 0 01-1.63 1.67v.19h-.18a7.83 7.83 0 01-2.82 1.53v.17l-.6.07a1.39 1.39 0 01.08.46 9 9 0 004.67-2.7z"
                />
              </g>
              <g id="prefix__Group_959" data-name="Group 959">
                <path
                  id="prefix__Path_690"
                  data-name="Path 690"
                  className="prefix__cls-7"
                  d="M37.59 26.75h.06l-.1-.05z"
                />
              </g>
              <g id="prefix__Group_960" data-name="Group 960">
                <path
                  id="prefix__Path_691"
                  data-name="Path 691"
                  className="prefix__cls-7"
                  d="M45.57 33.38l-.12.09h.17z"
                />
              </g>
              <g id="prefix__Group_961" data-name="Group 961">
                <path
                  id="prefix__Path_692"
                  data-name="Path 692"
                  className="prefix__cls-7"
                  d="M45.5 33.9l-.26-.17h-.07l-.3.22h.63z"
                />
              </g>
              <g id="prefix__Group_962" data-name="Group 962">
                <path
                  id="prefix__Path_693"
                  data-name="Path 693"
                  className="prefix__cls-7"
                  d="M25.29 39.51v.05h-.2a1.35 1.35 0 01-.92-.33 9.89 9.89 0 01-1.44 0h-.08v-.06a10.19 10.19 0 01-5-2.18 10.89 10.89 0 00-5.24-2.27.35.35 0 01-.14 0h-.31v-.08h-.34a.38.38 0 01-.09.34.49.49 0 01-.27.15l-.1.07a8.13 8.13 0 014.8 1.3v-.2h.27a.58.58 0 01.57.56v.2a.4.4 0 01.28.08l.09.07v.11l.1.07c.41.28.83.57 1.27.84a1 1 0 01.49-.13h.31v.32a.41.41 0 01-.08.24 8.35 8.35 0 001.8.75h.07v.05a9.15 9.15 0 003.57.22c.25 0 .49-.06.72-.11a.51.51 0 01-.13-.06z"
                />
              </g>
              <g id="prefix__Group_963" data-name="Group 963">
                <path
                  id="prefix__Path_694"
                  data-name="Path 694"
                  className="prefix__cls-7"
                  d="M10.68 35.28v-.21a.44.44 0 010-.34l-.51.05a8.7 8.7 0 00-5.33 2.46.49.49 0 01.06.17v.27l-.27.07h-.04a.45.45 0 01-.25 0c-.32.33-.64.68-.92 1s-.44.49-.68.74h.3l-.04.23h.1l.2-.06.54-.59.59-.65V38l.14.33c.23-.24.43-.45.63-.64l.08-.06.39-.34a.45.45 0 01.11-.49.41.41 0 01.46 0h.06a8.21 8.21 0 013.18-1.3v-.28l.67-.08v.26h.47z"
                />
              </g>
              <g id="prefix__Group_964" data-name="Group 964">
                <path
                  id="prefix__Path_695"
                  data-name="Path 695"
                  className="prefix__cls-7"
                  d="M33.47 33.25a.47.47 0 00.16-.21h-.08a15.76 15.76 0 00-2.48 2.35 13.3 13.3 0 01-2.73 2.51l.07.31-.41-.07h-.12a8 8 0 01-2.05.78 1.43 1.43 0 010 .22.29.29 0 000 .09v.23a8.35 8.35 0 002.75-1.16v-.12h.13a10.1 10.1 0 001.2-1 .37.37 0 01-.11-.38v-.14l.13-.06a.63.63 0 01.19 0H30.54c.28-.29.55-.59.78-.85l.74-.8h-.07v-.4l.07-.1a.43.43 0 01.27-.15l.06-.18h.24a.33.33 0 01.19.08V34a.77.77 0 01.5-.68z"
                />
              </g>
              <g id="prefix__Group_965" data-name="Group 965">
                <path
                  id="prefix__Path_696"
                  data-name="Path 696"
                  className="prefix__cls-7"
                  d="M37.38 32h.1-.09z"
                />
              </g>
              <g id="prefix__Group_966" data-name="Group 966">
                <path
                  id="prefix__Path_697"
                  data-name="Path 697"
                  className="prefix__cls-7"
                  d="M42.15 32v.24a.43.43 0 01-.13.3c.15.05.29.12.44.18h.32a.5.5 0 01.35.14.59.59 0 01.1.17l-.07-.53a8.37 8.37 0 00-1.01-.5z"
                />
              </g>
              <g id="prefix__Group_967" data-name="Group 967">
                <path
                  id="prefix__Path_698"
                  data-name="Path 698"
                  className="prefix__cls-7"
                  d="M41.8 31.14l.05-.05z"
                />
              </g>
              <g id="prefix__Group_968" data-name="Group 968">
                <path
                  id="prefix__Path_699"
                  data-name="Path 699"
                  className="prefix__cls-7"
                  d="M43.29 28.93c-.36.47-.7 1-1 1.44l.06.07v.16a.46.46 0 01-.07.3.54.54 0 01.28 0l.12-.18v-.18l.06-.09a.5.5 0 01.2-.15l.38-.54.11-.28.06-.12-.16-.36z"
                />
              </g>
              <g id="prefix__Group_969" data-name="Group 969">
                <path
                  id="prefix__Path_700"
                  data-name="Path 700"
                  className="prefix__cls-7"
                  d="M41.33 31.84h.08l.15-.05a.48.48 0 01.29 0h.18-.16l-.09-.12a.45.45 0 01-.06-.39l-.22.39v.06h-.07a8.5 8.5 0 00-1.6-.28.31.31 0 010 .08.43.43 0 01-.19.45c.24 0 .48 0 .72.08V32h.34a.54.54 0 01.63-.16z"
                />
              </g>
              <g id="prefix__Group_970" data-name="Group 970">
                <path
                  id="prefix__Path_701"
                  data-name="Path 701"
                  className="prefix__cls-7"
                  d="M48.53 35.54a.19.19 0 010 .12.08.08 0 000-.07z"
                />
              </g>
              <g id="prefix__Group_972" data-name="Group 972">
                <path
                  id="prefix__Path_703"
                  data-name="Path 703"
                  className="prefix__cls-7"
                  d="M1.14 41.57a3.69 3.69 0 00.4-.29.36.36 0 01-.16-.22v.09a.48.48 0 01-.25.35z"
                />
              </g>
              <g id="prefix__Group_973" data-name="Group 973">
                <path
                  id="prefix__Path_704"
                  data-name="Path 704"
                  className="prefix__cls-7"
                  d="M39.31 31.48a.09.09 0 000 .18.26.26 0 010-.15z"
                />
              </g>
              <g id="prefix__Group_974" data-name="Group 974">
                <path
                  id="prefix__Path_705"
                  data-name="Path 705"
                  className="prefix__cls-7"
                  d="M2.21 40.36h-.06.06z"
                />
              </g>
              <g id="prefix__Group_975" data-name="Group 975">
                <path
                  id="prefix__Path_706"
                  data-name="Path 706"
                  className="prefix__cls-7"
                  d="M52.47 36h-.07.15z"
                />
              </g>
              <g id="prefix__Group_976" data-name="Group 976">
                <path
                  id="prefix__Path_707"
                  data-name="Path 707"
                  className="prefix__cls-7"
                  d="M48.32 41z"
                />
              </g>
              <g id="prefix__Group_977" data-name="Group 977">
                <path
                  id="prefix__Path_708"
                  data-name="Path 708"
                  className="prefix__cls-7"
                  d="M47 40.23a.4.4 0 01.24-.33c-.48-.29-.94-.6-1.39-.91v.4l-.38.05c.4.27.81.56 1.24.82z"
                />
              </g>
              <g id="prefix__Group_978" data-name="Group 978">
                <path
                  id="prefix__Path_709"
                  data-name="Path 709"
                  className="prefix__cls-7"
                  d="M53.06 41.51l-.1-.07v.06a.15.15 0 00.1.06z"
                />
              </g>
              <g id="prefix__Group_979" data-name="Group 979">
                <path
                  id="prefix__Path_710"
                  data-name="Path 710"
                  className="prefix__cls-7"
                  d="M41.42 36.83V37.04a.12.12 0 000-.12.24.24 0 000-.1z"
                />
              </g>
              <g id="prefix__Group_980" data-name="Group 980">
                <path
                  id="prefix__Path_711"
                  data-name="Path 711"
                  className="prefix__cls-7"
                  d="M35.34 38l.2-.43c-.19.08-.37.18-.55.27h.08a.65.65 0 01.27.16z"
                />
              </g>
              <g id="prefix__Group_981" data-name="Group 981">
                <path
                  id="prefix__Path_712"
                  data-name="Path 712"
                  className="prefix__cls-7"
                  d="M34.6 38.68l-.12-.34h.12a.45.45 0 010-.28 9.87 9.87 0 00-1.81 1.47l.1.08a.5.5 0 01.22-.36.4.4 0 01.41 0v-.1.07h.06a.43.43 0 01.4 0c.25-.22.43-.41.62-.54z"
                />
              </g>
              <g id="prefix__Group_982" data-name="Group 982">
                <path
                  id="prefix__Path_713"
                  data-name="Path 713"
                  className="prefix__cls-7"
                  d="M32.9 39.66l-.17.22h.08a.52.52 0 01.11-.1.3.3 0 01-.02-.12z"
                />
              </g>
              <g id="prefix__Group_983" data-name="Group 983">
                <path
                  id="prefix__Path_714"
                  data-name="Path 714"
                  className="prefix__cls-7"
                  d="M51 41.45z"
                />
              </g>
              <g id="prefix__Group_984" data-name="Group 984">
                <path
                  id="prefix__Path_715"
                  data-name="Path 715"
                  className="prefix__cls-7"
                  d="M32.59 40.5a.36.36 0 01-.37-.35v-.07l-.29.32h.06l.2.09v.2A.34.34 0 0132 41a1.06 1.06 0 00-.41.1.37.37 0 01-.18 0h-.16a8.77 8.77 0 01-5.94 3.27 8.25 8.25 0 01-4.31-.49.76.76 0 010 .3 2.41 2.41 0 01.15.33l.41.14a.47.47 0 01.36-.1h.19l.07.19h.18a.14.14 0 010-.06l.11-.23.25.07a.36.36 0 01.26.33 10.59 10.59 0 002.32 0 8.66 8.66 0 005.07-2.23l-.31-.24.44-.38.38.3v-.23l.16.1c.38-.38.75-.79 1.07-1.15z"
                />
              </g>
              <g id="prefix__Group_986" data-name="Group 986">
                <path
                  id="prefix__Path_717"
                  data-name="Path 717"
                  className="prefix__cls-7"
                  d="M48.93 41.17v.23a.29.29 0 01.16 0l.07-.2h.33-.26a.44.44 0 01-.3-.03z"
                />
              </g>
              <g id="prefix__Group_987" data-name="Group 987">
                <path
                  id="prefix__Path_718"
                  data-name="Path 718"
                  className="prefix__cls-7"
                  d="M49.56 41.1h.16a.46.46 0 01.21.08v-.11h.24l-.36-.07-.07.09z"
                />
              </g>
              <g id="prefix__Group_988" data-name="Group 988">
                <path
                  id="prefix__Path_719"
                  data-name="Path 719"
                  className="prefix__cls-7"
                  d="M20.13 44.08v-.33l.17-.08-.06-.13a17.16 17.16 0 01-1.58-1 5.48 5.48 0 00-.52.31l.31.21.26-.33.47.37-.22.3c.39.25.78.48 1.19.69z"
                />
              </g>
              <g id="prefix__Group_989" data-name="Group 989">
                <path
                  id="prefix__Path_720"
                  data-name="Path 720"
                  className="prefix__cls-7"
                  d="M16.71 41.47l-.25-.21-.25-.1a2.77 2.77 0 00-.7-.18v.06l-.06.19.12.06h.58l-.2.17a16.67 16.67 0 011.52.93l.4-.24.12-.07-.64-.43.08.66-.66-1z"
                />
              </g>
              <g id="prefix__Group_990" data-name="Group 990">
                <path
                  id="prefix__Path_721"
                  data-name="Path 721"
                  className="prefix__cls-7"
                  d="M14.89 41z"
                />
              </g>
              <g id="prefix__Group_991" data-name="Group 991">
                <path
                  id="prefix__Path_722"
                  data-name="Path 722"
                  className="prefix__cls-7"
                  d="M5.59 42.68v-.16h.51a8.28 8.28 0 014.7-2 9.12 9.12 0 012.66 0v-.11l.27-.06a.47.47 0 01.17 0l.11-.26c-.31-.07-.62-.12-.93-.16a.44.44 0 01-.33.18 1.33 1.33 0 01-.2 0H11V40h-.24a8.91 8.91 0 00-5.57 2.7h.31z"
                />
              </g>
              <g id="prefix__Group_992" data-name="Group 992">
                <path
                  id="prefix__Path_723"
                  data-name="Path 723"
                  className="prefix__cls-7"
                  d="M4.42 44.18l-.06.26.1-.12.54-.63a.41.41 0 01.07-.22 1.45 1.45 0 01-.36 0 .55.55 0 01-.22.5z"
                />
              </g>
              <g id="prefix__Group_993" data-name="Group 993">
                <path
                  id="prefix__Path_724"
                  data-name="Path 724"
                  className="prefix__cls-7"
                  d="M43 37.81v.06l.19.08a.28.28 0 01-.11-.08z"
                />
              </g>
              <g id="prefix__Group_994" data-name="Group 994">
                <path
                  id="prefix__Path_725"
                  data-name="Path 725"
                  className="prefix__cls-7"
                  d="M44.78 38.7h.06v-.17h.32c-.32-.21-.67-.44-1-.65l.08.18a.67.67 0 010 .52l.43.27a.4.4 0 01.11-.15z"
                />
              </g>
              <g id="prefix__Group_995" data-name="Group 995">
                <path
                  id="prefix__Path_726"
                  data-name="Path 726"
                  className="prefix__cls-7"
                  d="M43.77 37.67h-.05l-.05.1H44z"
                />
              </g>
              <g id="prefix__Group_996" data-name="Group 996">
                <path
                  id="prefix__Path_727"
                  data-name="Path 727"
                  className="prefix__cls-7"
                  d="M43.36 38h.05z"
                />
              </g>
              <g id="prefix__Group_997" data-name="Group 997">
                <path
                  id="prefix__Path_728"
                  data-name="Path 728"
                  className="prefix__cls-7"
                  d="M42.51 37.12l-.27-.12h-.07a.49.49 0 01-.44 0v.27h-.39c.23.05.46.1.68.17a.38.38 0 01.11-.23.58.58 0 01.38-.09z"
                />
              </g>
              <g id="prefix__Group_998" data-name="Group 998">
                <path
                  id="prefix__Path_729"
                  data-name="Path 729"
                  className="prefix__cls-7"
                  d="M40.94 37.11l-.06.07a.3.3 0 01-.06.11l.35.05a.4.4 0 01-.23-.23z"
                />
              </g>
              <g id="prefix__Group_999" data-name="Group 999">
                <path
                  id="prefix__Path_730"
                  data-name="Path 730"
                  className="prefix__cls-7"
                  d="M3.1 45.16V45.5a.8.8 0 01.13.13l.21-.21h-.12v-.12a.79.79 0 01-.22-.14z"
                />
              </g>
              <g id="prefix__Group_1000" data-name="Group 1000">
                <path
                  id="prefix__Path_731"
                  data-name="Path 731"
                  className="prefix__cls-7"
                  d="M52.83 41.69a.55.55 0 01-.1-.25l-.07-.29a11.22 11.22 0 01-1.3 0v.09a.44.44 0 01-.45.43 9.78 9.78 0 001.92.02z"
                />
              </g>
              <g id="prefix__Group_1001" data-name="Group 1001">
                <path
                  id="prefix__Path_732"
                  data-name="Path 732"
                  className="prefix__cls-7"
                  d="M2.51 45.78l-.09-.16a8.06 8.06 0 01-1 .75.29.29 0 01-.2.13v.37h.12a.31.31 0 01.21.07 9.2 9.2 0 001.06-.8 1 1 0 01-.12-.23z"
                />
              </g>
              <g id="prefix__Group_1002" data-name="Group 1002">
                <path
                  id="prefix__Path_733"
                  data-name="Path 733"
                  className="prefix__cls-7"
                  d="M3.66 44.51v-.12l-.1.11.12.08a.15.15 0 01-.02-.07z"
                />
              </g>
              <g id="prefix__Group_1003" data-name="Group 1003">
                <path
                  id="prefix__Path_734"
                  data-name="Path 734"
                  className="prefix__cls-7"
                  d="M4.2 50.53c.31-.32.6-.64.88-1a.82.82 0 01-.19-.09l-.05.05v-.11l-.1-.08a.44.44 0 00-.1-.08c-.25.29-.51.58-.78.86z"
                />
              </g>
              <g id="prefix__Group_1004" data-name="Group 1004">
                <path
                  id="prefix__Path_735"
                  data-name="Path 735"
                  className="prefix__cls-7"
                  d="M1.87 51.76z"
                />
              </g>
              <g id="prefix__Group_1005" data-name="Group 1005">
                <path
                  id="prefix__Path_736"
                  data-name="Path 736"
                  className="prefix__cls-7"
                  d="M2.16 51.8a.36.36 0 01.13.19.26.26 0 010 .15 10.12 10.12 0 001.54-1.24v-.75a11.43 11.43 0 01-1.2 1.1.36.36 0 010 .23.5.5 0 01-.34.31z"
                />
              </g>
              <g id="prefix__Group_1006" data-name="Group 1006">
                <path
                  id="prefix__Path_737"
                  data-name="Path 737"
                  className="prefix__cls-7"
                  d="M20.53 49.07a.53.53 0 010-.49c-.57-.32-1.12-.7-1.65-1.06a11.75 11.75 0 00-4.42-2.15l-.19.07h-.07a.36.36 0 01-.34-.15h-.09a.66.66 0 01.06.27v.11l-.07.09a.24.24 0 01-.09.08 7.68 7.68 0 011.78.41.35.35 0 01.22.08A15.4 15.4 0 0118.54 48a19.93 19.93 0 002.3 1.41v-.14a.39.39 0 01-.31-.2z"
                />
              </g>
              <g id="prefix__Group_1007" data-name="Group 1007">
                <path
                  id="prefix__Path_738"
                  data-name="Path 738"
                  className="prefix__cls-7"
                  d="M21.06 49.45H21h.05a.08.08 0 01.01 0z"
                />
              </g>
              <g id="prefix__Group_1008" data-name="Group 1008">
                <path
                  id="prefix__Path_739"
                  data-name="Path 739"
                  className="prefix__cls-7"
                  d="M42.74 42.46z"
                />
              </g>
              <g id="prefix__Group_1009" data-name="Group 1009">
                <path
                  id="prefix__Path_740"
                  data-name="Path 740"
                  className="prefix__cls-7"
                  d="M8.58 46.64l-.17-.06a.56.56 0 010 .12z"
                />
              </g>
              <g id="prefix__Group_1010" data-name="Group 1010">
                <path
                  id="prefix__Path_741"
                  data-name="Path 741"
                  className="prefix__cls-7"
                  d="M9.85 45.75h.68l-.27-.13a.65.65 0 01-.24 0l-.12.06a3.11 3.11 0 01-.55.27V46a.64.64 0 00.28-.06l.08-.13z"
                />
              </g>
              <g id="prefix__Group_1011" data-name="Group 1011">
                <path
                  id="prefix__Path_742"
                  data-name="Path 742"
                  className="prefix__cls-7"
                  d="M11.4 45.29c-.24 0-.47.06-.71.1v.41l-.18-.09v.27c.29-.06.59-.11.89-.15l.85-.06v-.3h.29a.41.41 0 01.37-.07 10.07 10.07 0 00-1.51-.11z"
                />
              </g>
              <g id="prefix__Group_1012" data-name="Group 1012">
                <path
                  id="prefix__Path_743"
                  data-name="Path 743"
                  className="prefix__cls-7"
                  d="M38.1 42.68H38a.11.11 0 00.1 0z"
                />
              </g>
              <g id="prefix__Group_1013" data-name="Group 1013">
                <path
                  id="prefix__Path_744"
                  data-name="Path 744"
                  className="prefix__cls-7"
                  d="M6.74 47.88a8.45 8.45 0 01.75-.59.67.67 0 010-.28.55.55 0 01-.25-.2 12.93 12.93 0 00-1.76 1.55h.72l.41-.36a.49.49 0 01.13-.12z"
                />
              </g>
              <g id="prefix__Group_1014" data-name="Group 1014">
                <path
                  id="prefix__Path_745"
                  data-name="Path 745"
                  className="prefix__cls-7"
                  d="M21.87 49.56a.12.12 0 00.05.07z"
                />
              </g>
              <g id="prefix__Group_1015" data-name="Group 1015">
                <path
                  id="prefix__Path_746"
                  data-name="Path 746"
                  className="prefix__cls-7"
                  d="M21.87 49.54a.13.13 0 01.05-.07.1.1 0 00-.05.07z"
                />
              </g>
              <g id="prefix__Group_1016" data-name="Group 1016">
                <path
                  id="prefix__Path_747"
                  data-name="Path 747"
                  className="prefix__cls-7"
                  d="M30.22 48.64z"
                />
              </g>
              <g id="prefix__Group_1017" data-name="Group 1017">
                <path
                  id="prefix__Path_748"
                  data-name="Path 748"
                  className="prefix__cls-7"
                  d="M30.29 48.53a.1.1 0 00-.07.1.13.13 0 01.07-.1z"
                />
              </g>
              <g id="prefix__Group_1018" data-name="Group 1018">
                <path
                  id="prefix__Path_749"
                  data-name="Path 749"
                  className="prefix__cls-7"
                  d="M30.86 47.43a8 8 0 01-2.19 1.5l-.05.56v.06a7.19 7.19 0 001.45-.77l-.07-.13v-.15a.33.33 0 01.36-.2.32.32 0 01.17.1l.22-.18v-.1a.36.36 0 01.36-.23l.23-.22h-.18a.33.33 0 01-.37-.25z"
                />
              </g>
              <g id="prefix__Group_1019" data-name="Group 1019">
                <path
                  id="prefix__Path_750"
                  data-name="Path 750"
                  className="prefix__cls-7"
                  d="M21.7 49.7v.06h.12z"
                />
              </g>
              <g id="prefix__Group_1020" data-name="Group 1020">
                <path
                  id="prefix__Path_751"
                  data-name="Path 751"
                  className="prefix__cls-7"
                  d="M21.51 49.16a.19.19 0 00.17.21.18.18 0 00.2-.13l-.36-.14a.13.13 0 01-.01.06z"
                />
              </g>
              <g id="prefix__Group_1021" data-name="Group 1021">
                <path
                  id="prefix__Path_752"
                  data-name="Path 752"
                  className="prefix__cls-7"
                  d="M31.33 47a.51.51 0 01.18.38v.2c.42-.41.81-.84 1.19-1.27.14-.14.27-.29.4-.43h-.14l-.09-.14a.32.32 0 01-.06-.23l.06-.16v-.06l.18.08a1 1 0 01.17-.1l.32-.21.08.23L34 45v-.05l-.14-.07h-.26v-.13h-.2c-.38.38-.74.78-1.09 1.16s-.64.72-.98 1.09z"
                />
              </g>
              <g id="prefix__Group_1022" data-name="Group 1022">
                <path
                  id="prefix__Path_753"
                  data-name="Path 753"
                  className="prefix__cls-7"
                  d="M27.22 49.63l.42-.1v.37l.28-.09h-.19l.13-.33a.45.45 0 01.3-.24l.37-.2a8.69 8.69 0 01-1.86.57v.06a.38.38 0 010 .21h.18a.69.69 0 01.37-.25z"
                />
              </g>
              <g id="prefix__Group_1023" data-name="Group 1023">
                <path
                  id="prefix__Path_754"
                  data-name="Path 754"
                  className="prefix__cls-7"
                  d="M24.18 49.72v.09a.35.35 0 01-.05.33l-.06.08h-.14a9.31 9.31 0 001.67 0l.07-.07a.47.47 0 01.55 0h.2v-.05h-.1a.33.33 0 01-.26-.22.37.37 0 010-.21h-.13a9.29 9.29 0 01-1.75.05z"
                />
              </g>
              <g id="prefix__Group_1024" data-name="Group 1024">
                <path
                  id="prefix__Path_755"
                  data-name="Path 755"
                  className="prefix__cls-7"
                  d="M23.35 49.63a7.87 7.87 0 01-1.09-.26.42.42 0 010 .15.33.33 0 01-.23.34H22a8.07 8.07 0 001.69.36.57.57 0 01-.28-.35z"
                />
              </g>
              <g id="prefix__Group_1025" data-name="Group 1025">
                <path
                  id="prefix__Path_756"
                  data-name="Path 756"
                  className="prefix__cls-7"
                  d="M1.93 52.17H2h-.08z"
                />
              </g>
              <g id="prefix__Group_1027" data-name="Group 1027">
                <path
                  id="prefix__Path_758"
                  data-name="Path 758"
                  className="prefix__cls-7"
                  d="M18.58 52.78h-.06l.07.05z"
                />
              </g>
              <g id="prefix__Group_1028" data-name="Group 1028">
                <path
                  id="prefix__Path_759"
                  data-name="Path 759"
                  className="prefix__cls-7"
                  d="M8.57 52.23a.51.51 0 01.06-.23l.08-.11h.14a.38.38 0 01.29.09 6.81 6.81 0 01.78-.34l-.37-.07h-.32a.52.52 0 01-.2-.09 9.6 9.6 0 00-2.65 1.82v.07a.11.11 0 000 .05v-.07h.26v.31l-.31.18-.2-.12-.14.3-.22-.24-.53.58a14.86 14.86 0 01-2.48 2.34v.08a.1.1 0 00.05 0L3 57l.15.18a15.79 15.79 0 002.52-2.38 12.86 12.86 0 012.9-2.57z"
                />
              </g>
              <g id="prefix__Group_1029" data-name="Group 1029">
                <path
                  id="prefix__Path_760"
                  data-name="Path 760"
                  className="prefix__cls-7"
                  d="M9.9 51.13l.18.4a9.13 9.13 0 012-.44 8.17 8.17 0 014.37.55l.49-.06v.3c.33.17.67.36 1.05.6l.06-.08v-.25h.34a9.28 9.28 0 00-4-1.54h-.07a3.15 3.15 0 01-.43-.05 11.57 11.57 0 00-1.86.06 11.13 11.13 0 00-2.14.38.45.45 0 01.01.13z"
                />
              </g>
              <g id="prefix__Group_1030" data-name="Group 1030">
                <path
                  id="prefix__Path_761"
                  data-name="Path 761"
                  className="prefix__cls-7"
                  d="M47.66 50v-.05z"
                />
              </g>
              <g id="prefix__Group_1031" data-name="Group 1031">
                <path
                  id="prefix__Path_762"
                  data-name="Path 762"
                  className="prefix__cls-7"
                  d="M47.7 50.31a.09.09 0 010-.07v.08z"
                />
              </g>
              <g id="prefix__Group_1032" data-name="Group 1032">
                <path
                  id="prefix__Path_763"
                  data-name="Path 763"
                  className="prefix__cls-7"
                  d="M49.07 51.08h.08-.14z"
                />
              </g>
              <g id="prefix__Group_1033" data-name="Group 1033">
                <path
                  id="prefix__Path_764"
                  data-name="Path 764"
                  className="prefix__cls-7"
                  d="M49.07 51.09h.07z"
                />
              </g>
              <g id="prefix__Group_1034" data-name="Group 1034">
                <path
                  id="prefix__Path_765"
                  data-name="Path 765"
                  className="prefix__cls-7"
                  d="M49.17 51.34z"
                />
              </g>
              <g id="prefix__Group_1035" data-name="Group 1035">
                <path
                  id="prefix__Path_766"
                  data-name="Path 766"
                  className="prefix__cls-7"
                  d="M49.12 51.26v.06-.07z"
                />
              </g>
              <g id="prefix__Group_1036" data-name="Group 1036">
                <path
                  id="prefix__Path_767"
                  data-name="Path 767"
                  className="prefix__cls-7"
                  d="M3.72 62.53a.39.39 0 01-.14.08 1 1 0 01-.35 0v.19h.1z"
                />
              </g>
              <g id="prefix__Group_1037" data-name="Group 1037">
                <path
                  id="prefix__Path_768"
                  data-name="Path 768"
                  className="prefix__cls-7"
                  d="M12.1 56.43z"
                />
              </g>
              <g id="prefix__Group_1038" data-name="Group 1038">
                <path
                  id="prefix__Path_769"
                  data-name="Path 769"
                  className="prefix__cls-7"
                  d="M4.52 61.18l-.6.52h.24v.25a.49.49 0 010 .24h.06v-.09l.25-.1c.18-.15.36-.32.56-.51H4.9l.25-.49a.63.63 0 01.5-.22c.23-.24.45-.49.67-.73a18.13 18.13 0 011.91-1.91h-.56v-.29a22.33 22.33 0 00-1.81 1.83c-.37.41-.79.88-1.23 1.3a.32.32 0 01-.11.2z"
                />
              </g>
              <g id="prefix__Group_1039" data-name="Group 1039">
                <path
                  id="prefix__Path_770"
                  data-name="Path 770"
                  className="prefix__cls-7"
                  d="M11.21 56.11l-.09.2a.3.3 0 01-.25.18h-.36v-.19a8.39 8.39 0 00-2.1 1.09h.36v.25a.25.25 0 010 .12 8 8 0 013.3-1.34.41.41 0 010-.52l.06-.06a7.38 7.38 0 00-1 .21z"
                />
              </g>
              <g id="prefix__Group_1040" data-name="Group 1040">
                <path
                  id="prefix__Path_771"
                  data-name="Path 771"
                  className="prefix__cls-7"
                  d="M10.86 56.28z"
                />
              </g>
              <g id="prefix__Group_1041" data-name="Group 1041">
                <path
                  id="prefix__Path_772"
                  data-name="Path 772"
                  className="prefix__cls-7"
                  d="M20.62 59l.2.13a.39.39 0 00-.2-.13z"
                />
              </g>
              <g id="prefix__Group_1042" data-name="Group 1042">
                <path
                  id="prefix__Path_773"
                  data-name="Path 773"
                  className="prefix__cls-7"
                  d="M12.6 56a.57.57 0 01.11.28 8.25 8.25 0 014.7.71.3.3 0 01.36.18c.45.24.88.5 1.3.78h.12l.54.13h.63v-.07L20.1 58c-1.92-1.31-3.9-2.66-7.46-2.24h-.11z"
                />
              </g>
              <g id="prefix__Group_1043" data-name="Group 1043">
                <path
                  id="prefix__Path_774"
                  data-name="Path 774"
                  className="prefix__cls-7"
                  d="M15.3 61.11l-.13-.11a10.46 10.46 0 00-1.94 0q-.6.08-1.2.21a.48.48 0 01-.16.34l-.43.37-.06-.53a8.92 8.92 0 00-3.73 2.32H8a.48.48 0 01.37.2A8 8 0 0111.49 62l.19-.11a10.82 10.82 0 013.3-.39.47.47 0 010-.16.6.6 0 01.32-.23z"
                />
              </g>
              <g id="prefix__Group_1044" data-name="Group 1044">
                <path
                  id="prefix__Path_775"
                  data-name="Path 775"
                  className="prefix__cls-7"
                  d="M20.73 63.28a12 12 0 00-4.26-2.11.37.37 0 01.08.18l.06.3-.28.05a7.75 7.75 0 011.94.7v-.1l.48.34a.64.64 0 01.22.14c.42.25.83.53 1.22.8l.06-.1h.32a.81.81 0 01.31 0H21l.06-.05z"
                />
              </g>
              <g id="prefix__Group_1045" data-name="Group 1045">
                <path
                  id="prefix__Path_776"
                  data-name="Path 776"
                  className="prefix__cls-7"
                  d="M7.72 64.25v-.1l-.13-.25-.32.33v.39L7 64.43l-.45.57a13.3 13.3 0 01-2.8 2.55l.07.6a11.57 11.57 0 002.67-2.26.43.43 0 01.21-.5.4.4 0 01.24 0l-.05-.19h.25l.66-.71a1.3 1.3 0 00-.08-.24z"
                />
              </g>
              <g id="prefix__Group_1046" data-name="Group 1046">
                <path
                  id="prefix__Path_777"
                  data-name="Path 777"
                  className="prefix__cls-7"
                  d="M7 65.38z"
                />
              </g>
              <g id="prefix__Group_1047" data-name="Group 1047">
                <path
                  id="prefix__Path_778"
                  data-name="Path 778"
                  className="prefix__cls-7"
                  d="M55.77 62.73l-.37.42a2.2 2.2 0 001 .07.46.46 0 01.15-.5l.08-.06h.1a.49.49 0 01.33.07.4.4 0 01-.3-.22.49.49 0 010-.53l.1-.12h.3a2.62 2.62 0 00-1-.85h-.09a.5.5 0 01-.21 0 .44.44 0 01-.29.16h-.21l.43.27c.48.29.94.57.8 1 0 .07-.18.4-.82.29z"
                />
              </g>
              <g id="prefix__Group_1048" data-name="Group 1048">
                <path
                  id="prefix__Path_779"
                  data-name="Path 779"
                  className="prefix__cls-7"
                  d="M52.18 62a.44.44 0 01-.35.24h-.3l-.1-.28a.36.36 0 010-.23A14.12 14.12 0 0148.37 60l-.37-.26c-.26.06-.51.11-.77.15l.83.56c1.68 1.15 3.42 2.34 6.24 2.31l.5-.38v.43l.94-.27a.3.3 0 000-.16.28.28 0 00-.31-.25c-.25 0-.51.06-.77.07a2.54 2.54 0 01-.32-.34l-.34.34a7.38 7.38 0 01-1.82-.2z"
                />
              </g>
              <g id="prefix__Group_1050" data-name="Group 1050">
                <path
                  id="prefix__Path_781"
                  data-name="Path 781"
                  className="prefix__cls-7"
                  d="M55.3 61l-.06-.14h-.07z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
